// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%230f766e%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27m2 5 6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Audit Process page */
.audit-process-page {
  min-height: 100%;
  padding-bottom: 2rem;
  background: none;
}

/* Dark header */
.audit-process-header {
  color: #000000;
  padding: 1rem 0;
  flex-shrink: 0;
}

.audit-process-header-inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;
}

.audit-process-breadcrumb .breadcrumb {
  background: transparent;
  padding: 0;
  margin: 0;
  font-size: 0.9rem;
  color: var(--tblr-secondary, #6c757d);
}

.audit-process-breadcrumb .breadcrumb-item a {
  color: var(--tblr-secondary, #6c757d);
  text-decoration: none;
}

.audit-process-breadcrumb .breadcrumb-item a:hover {
  color: var(--tblr-body-color, #1e293b);
}

.audit-process-breadcrumb .breadcrumb-item.active {
  color: var(--tblr-secondary, #6c757d);
}

.audit-process-breadcrumb .breadcrumb-item + .breadcrumb-item::before {
  color: var(--tblr-secondary, #6c757d);
}


/* BE-driven Initial Certification stage overview */
.audit-initial-stage-stepper {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  margin-bottom: 1rem;
  padding: 0.8rem 0.9rem;
  border: 1px solid #d9e7e8;
  border-radius: 12px;
  background: #f8fbfc;
  overflow-x: auto;
}

.audit-initial-stage-step {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  min-width: max-content;
  color: #718096;
  font-size: 0.8rem;
  font-weight: 700;
}

.audit-initial-stage-step__icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.65rem;
  height: 1.65rem;
  border-radius: 50%;
  background: #e2e8f0;
  color: #64748b;
  font-size: 0.72rem;
}

.audit-initial-stage-step.is-current {
  color: #0f766e;
}

.audit-initial-stage-step.is-current .audit-initial-stage-step__icon {
  background: #0f9f95;
  color: #fff;
  box-shadow: 0 0 0 4px rgba(15, 159, 149, 0.12);
}

.audit-initial-stage-step.is-completed {
  color: #3f7d15;
}

.audit-initial-stage-step.is-completed .audit-initial-stage-step__icon {
  background: #65a30d;
  color: #fff;
}

.audit-initial-stage-step.is-locked {
  color: #94a3b8;
}

.audit-initial-stage-step.needs-revision .audit-initial-stage-step__icon {
  background: #f59e0b;
  color: #fff;
}

.audit-initial-stage-step__line {
  width: 34px;
  min-width: 34px;
  height: 2px;
  background: #d4dee4;
}

/* Inline stepper inside each stage card */
.audit-process-inline-stepper {
  position: relative;
  margin-bottom: 1rem;
  border: 1px solid #cfe7e5;
  border-radius: 14px;
  background: linear-gradient(135deg, #f8fffe 0%, #f3fbff 48%, #f7fbff 100%);
  padding: 0.95rem;
  overflow: hidden;
  box-shadow: 0 12px 28px rgba(15, 118, 110, 0.08);
}

.audit-process-inline-stepper::before {
  content: '';
  position: absolute;
  width: 260px;
  height: 260px;
  border-radius: 50%;
  right: -110px;
  top: -130px;
  background: radial-gradient(circle at center, rgba(45, 212, 191, 0.2) 0%, rgba(45, 212, 191, 0) 70%);
  pointer-events: none;
}

.audit-process-inline-stepper-major {
  display: flex;
  align-items: stretch;
  gap: 0.55rem;
  overflow-x: auto;
  padding-bottom: 0.15rem;
  scrollbar-width: thin;
}

.audit-process-inline-major-item {
  min-width: 170px;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  border: 1px solid #d6dde6;
  border-radius: 10px;
  background: linear-gradient(180deg, #f8fbff 0%, #f2f6fb 100%);
  padding: 0.55rem 0.65rem;
  color: #5f7089;
  transition: transform 0.16s ease, box-shadow 0.16s ease, border-color 0.16s ease;
}

.audit-process-inline-major-item:hover {
  transform: translateY(-1px);
  box-shadow: 0 6px 14px rgba(148, 163, 184, 0.2);
}

.audit-process-inline-major-item.is-current {
  position: relative;
  overflow: hidden;
  border-color: #14b8a6;
  background: linear-gradient(135deg, #dcfffb 0%, #e6fffb 60%, #effffb 100%);
  color: #0f766e;
  box-shadow: 0 0 0 1px rgba(20, 184, 166, 0.2), 0 10px 18px rgba(13, 148, 136, 0.16);
}

.audit-process-inline-major-item.is-current::after {
  content: '';
  position: absolute;
  top: -120%;
  left: -46%;
  width: 44%;
  height: 340%;
  transform: rotate(25deg);
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.34) 45%,
    rgba(255, 255, 255, 0) 100%
  );
  animation: audit-process-shimmer 4.8s ease-in-out infinite;
  pointer-events: none;
}

.audit-process-inline-major-item.is-completed {
  border-color: #84cc16;
  background: linear-gradient(180deg, #f8ffe8 0%, #ecfccb 100%);
  color: #4d7c0f;
}

.audit-process-inline-major-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.75rem;
  height: 1.75rem;
  border-radius: 0.45rem;
  background: #dbe1e8;
  color: #4b5563;
  font-size: 0.88rem;
  font-weight: 700;
  flex-shrink: 0;
}

.audit-process-inline-major-item.is-current .audit-process-inline-major-num {
  background: #20a29c;
  color: #ffffff;
}

.audit-process-inline-major-item.is-completed .audit-process-inline-major-num {
  background: #8ac926;
  color: #ffffff;
}

.audit-process-inline-major-text {
  font-size: 0.84rem;
  line-height: 1.2;
  font-weight: 600;
}

.audit-process-inline-major-divider {
  width: 18px;
  min-width: 18px;
  align-self: center;
  height: 2px;
  background: linear-gradient(90deg, #d9dde3 0%, #c7d0db 100%);
}

.audit-process-inline-stepper-sub {
  margin-top: 0.7rem;
  display: flex;
  align-items: center;
  gap: 0.55rem;
  overflow-x: auto;
  padding: 0.5rem 0.4rem 0.25rem;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.72);
  border: 1px dashed #dbe4ee;
  scrollbar-width: thin;
}

.audit-process-inline-sub-item {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  color: #64748b;
  font-size: 0.86rem;
  font-weight: 600;
  white-space: nowrap;
}

.audit-process-inline-sub-item.is-current {
  color: #0f766e;
}

.audit-process-inline-sub-item.is-completed {
  color: #4d7c0f;
}

.audit-process-inline-sub-dot {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 2px solid #cbd5e1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #ffffff;
  background: #f8fafc;
  flex-shrink: 0;
}

.audit-process-inline-sub-item.is-current .audit-process-inline-sub-dot {
  border-color: #20a29c;
  background: #20a29c;
}

.audit-process-inline-sub-item.is-completed .audit-process-inline-sub-dot {
  border-color: #8ac926;
  background: #8ac926;
}

.audit-process-inline-sub-divider {
  width: 46px;
  min-width: 46px;
  height: 2px;
  background: #d9dde3;
}

/* Compact one-line "Audit Completed" summary — replaces the full major-step
   chip breakdown + celebration banner once every stage is done, since at
   that point the group-level Stage overview above already shows the same
   completion. Much shorter than the two elements it replaces. */
.audit-process-completed-summary {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.6rem;
  padding: 0.6rem 0.9rem;
  border-radius: 10px;
  background: linear-gradient(135deg, #ecfdf5 0%, #eafffb 100%);
  border: 1px solid #99e6da;
  color: #0f766e;
  font-size: 0.85rem;
}

.audit-process-completed-summary-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 1.35rem;
  height: 1.35rem;
  border-radius: 50%;
  background: #14b8a6;
  color: #fff;
  font-weight: 700;
  font-size: 0.72rem;
  flex-shrink: 0;
}

.audit-process-completed-summary-text {
  flex: 1 1;
  min-width: 200px;
  font-weight: 600;
}

.audit-process-completed-summary-link {
  flex-shrink: 0;
  font-weight: 700;
  font-size: 0.8rem;
  color: #0d3d42;
  background: #fff;
  padding: 0.3rem 0.75rem;
  border-radius: 6px;
  text-decoration: none;
  white-space: nowrap;
}

.audit-process-completed-summary-link:hover {
  color: #0d3d42;
  background: #dcfffb;
}

.audit-process-completed-summary-link:focus-visible {
  outline: 2px solid #0d9488;
  outline-offset: 2px;
}

/* Documents/Forms doc row — was a single-line d-flex justify-content-between
   that overflowed on mobile once the scope badge + 3 export buttons + upload
   + form button all fought for the same row. Scope is now shown once in the
   selector above, exports are gone, and the row wraps to a stacked layout
   below 576px instead of clipping. */
.audit-process-doc-row-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.6rem;
  padding: 0.85rem 1rem;
}

.audit-process-doc-row-title {
  min-width: 0;
  flex: 1 1 220px;
}

.audit-process-doc-row-actions {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.5rem;
  flex-shrink: 0;
}

/* Native controls are covered by the fieldset, but custom selects and their
   remove buttons render as non-native elements. Keep the form readable while
   preventing every edit interaction in the explicit read-only view. */
.audit-form-read-only button,
.audit-form-read-only input,
.audit-form-read-only select,
.audit-form-read-only textarea,
.audit-form-read-only [role='combobox'],
.audit-form-read-only [contenteditable='true'],
.audit-form-read-only [class*='multi-value__remove'] {
  pointer-events: none !important;
}

@media (max-width: 575.98px) {
  .audit-process-doc-row-top {
    flex-direction: column;
    align-items: stretch;
  }

  .audit-process-doc-row-actions {
    justify-content: flex-start;
  }
}

.audit-process-card {
  border: 1px solid var(--tblr-border-color, #e6e7e9);
  border-radius: 8px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.audit-process-card-header {
  background: var(--tblr-bg-surface-secondary, #f8f9fa);
  border-bottom: 1px solid var(--tblr-border-color, #e6e7e9);
  padding: 0.75rem 1rem;
  font-weight: 600;
}

.audit-process-card-main .card-body {
  padding: 1.25rem;
}

/* Teal buttons (match design accent) */
.audit-process-page .btn-teal {
  background: #0d9488;
  color: #fff;
  border: none;
  padding: 0.5rem 1.25rem;
  border-radius: 6px;
}

.audit-process-page .btn-teal:hover {
  background: #0f766e;
  color: #fff;
}

/* Title & project ID */
.audit-process-title {
  font-size: 1.35rem;
  font-weight: 600;
  color: var(--tblr-body-color, #1e293b);
}

.audit-process-project-id {
  font-weight: 500;
  color: var(--tblr-muted, #64748b);
}

/* Audit stages (collapsible) – card-style like design */
.audit-process-stages {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  margin-top: 1rem;
}

.audit-process-stage-item {
  background: #fff;
  border: 1px solid var(--tblr-border-color, #e6e7e9);
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.audit-process-stage-item.is-expanded {
  position: relative;
  border-color: #5eead4;
  box-shadow: 0 10px 24px rgba(13, 148, 136, 0.16);
}

.audit-process-stage-item.is-expanded::after {
  content: '';
  position: absolute;
  top: -50%;
  left: -28%;
  width: 32%;
  height: 220%;
  transform: rotate(20deg);
  background: linear-gradient(
    90deg,
    rgba(255, 255, 255, 0) 0%,
    rgba(255, 255, 255, 0.28) 48%,
    rgba(255, 255, 255, 0) 100%
  );
  animation: audit-process-shimmer 6s ease-in-out infinite;
  pointer-events: none;
}

.audit-process-stage-item-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.875rem 1rem;
  cursor: pointer;
  transition: background 0.15s ease;
}

.audit-process-stage-item-header:hover {
  background: var(--tblr-bg-surface-secondary, #f8f9fa);
}

.audit-process-stage-item.is-expanded .audit-process-stage-item-header {
  background: linear-gradient(135deg, #ecfeff 0%, #f0fdfa 100%);
  border-bottom: 1px solid #99f6e4;
}

.audit-process-stage-item.is-expanded .audit-process-stage-name {
  color: #0f766e;
}

.audit-process-stage-item.is-expanded .audit-process-stage-chevron {
  color: #0f766e;
}

.audit-process-stage-item-header-left {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.audit-process-stage-name {
  font-weight: 600;
  font-size: 1rem;
  color: var(--tblr-body-color, #1e293b);
}

.audit-process-stage-status.badge {
  font-size: 0.8rem;
  font-weight: 500;
  padding: 0.25em 0.6em;
  border-radius: 9999px;
}

.audit-process-stage-status.badge-audit-completed {
  background: rgba(25, 135, 84, 0.15);
  color: #198754;
}

.audit-process-stage-status.badge-checklist {
  background: #fef3c7;
  color: #b45309;
}

.audit-process-stage-status.badge-next-audit {
  background: #e2e8f0;
  color: #475569;
}

.audit-process-stage-service-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.22rem 0.6rem;
  border-radius: 9999px;
  font-size: 0.78rem;
  font-weight: 700;
  color: #1d4ed8;
  background: #dbeafe;
  border: 1px solid #93c5fd;
}

.audit-process-stage-chevron {
  flex-shrink: 0;
  color: var(--tblr-muted, #64748b);
  transition: transform 0.2s ease;
}

.audit-process-stage-chevron.open {
  transform: rotate(180deg);
}

.audit-process-stage-item-body {
  padding: 0 1rem 1rem;
  border-top: 1px solid var(--tblr-border-color-translucent, rgba(0, 0, 0, 0.06));
  padding-top: 1rem;
  margin-left: 0;
  margin-right: 0;
}

.audit-process-stage-fields {
  display: grid;
  grid-template-columns: 1fr 1fr 2fr;
  gap: 1.25rem;
  margin-bottom: 1rem;
}

@media (max-width: 768px) {
  .audit-process-stage-fields {
    grid-template-columns: 1fr;
  }
}

/* Sustainability/ISCC scope stages show more fields (Registration Number, Input/Output
   Material, GHG Calculation) instead of EA Code -- use an even grid so extra fields
   don't inherit the wide 2fr column meant for Scope, with Scope always spanning full width. */
.audit-process-stage-fields.is-sustainability {
  grid-template-columns: repeat(2, 1fr);
}

.audit-process-stage-fields.is-sustainability .audit-process-stage-field-scope {
  grid-column: 1 / -1;
}

@media (max-width: 768px) {
  .audit-process-stage-fields.is-sustainability {
    grid-template-columns: 1fr;
  }
}

/* Collapsed Mandays/EA Code/Scope summary for a fully completed cycle — one
   adaptive line instead of the full 3-column grid, click to expand. */
.audit-process-stage-fields-summary {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 0.4rem;
  width: 100%;
  margin-bottom: 1rem;
  padding: 0.6rem 0.85rem;
  border: 1px dashed #cdd9e6;
  border-radius: 10px;
  background: #f8fafc;
  color: #334155;
  font-size: 0.82rem;
  text-align: left;
  cursor: pointer;
  transition-property: background-color, border-color;
  transition-duration: 150ms;
  transition-timing-function: ease-out;
}

.audit-process-stage-fields-summary:hover {
  background: #eef2f7;
  border-color: #b7c6d8;
}

.audit-process-stage-fields-summary:focus-visible {
  outline: 2px solid #14b8a6;
  outline-offset: 2px;
}

.audit-process-stage-fields-summary strong {
  color: #0f766e;
  font-weight: 700;
  margin-right: 0.3rem;
}

.audit-process-stage-fields-summary-sep {
  color: #b0bec9;
}

.audit-process-stage-fields-summary-scope {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1 1 160px;
}

.audit-process-stage-fields-summary-cta {
  flex-shrink: 0;
  margin-left: auto;
  font-weight: 700;
  color: #14b8a6;
  text-decoration: underline;
}

.audit-process-stage-fields-toggle {
  display: inline-flex;
  align-items: center;
  margin: 0 0 1rem;
  padding: 0.3rem 0;
  min-height: 40px;
  border: none;
  background: none;
  font-size: 0.78rem;
  font-weight: 700;
  color: #0f766e;
  text-decoration: underline;
  cursor: pointer;
  transition-property: color;
  transition-duration: 150ms;
  transition-timing-function: ease-out;
}

.audit-process-stage-fields-toggle:hover,
.audit-process-stage-fields-toggle:focus-visible {
  color: #14b8a6;
}

.audit-process-stage-fields-toggle:focus-visible {
  outline: 2px solid #14b8a6;
  outline-offset: 2px;
  border-radius: 4px;
}

@media (max-width: 575.98px) {
  .audit-process-stage-fields-summary-cta {
    margin-left: 0;
    flex-basis: 100%;
  }
}

.audit-process-fscp03-toggle {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-height: 48px;
  padding: 0.85rem 1rem;
  border: none;
  background: #f8fafc;
  cursor: pointer;
  text-align: left;
  transition-property: background-color;
  transition-duration: 150ms;
  transition-timing-function: ease-out;
}

.audit-process-fscp03-toggle:hover {
  background: #f1f5f9;
}

.audit-process-fscp03-toggle:focus-visible {
  outline: 2px solid #14b8a6;
  outline-offset: -2px;
}

.audit-process-fscp03-toggle-chevron {
  color: #64748b;
  flex-shrink: 0;
  transition-property: transform;
  transition-duration: 150ms;
  transition-timing-function: ease-out;
}

.audit-process-fscp03-toggle-chevron.open {
  transform: rotate(180deg);
}

.audit-process-stage-field {
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  padding: 0.8rem 0.85rem;
  border: 1px solid #dbe5f0;
  border-radius: 12px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.7);
}

.audit-process-stage-field-label {
  font-size: 0.875rem;
  font-weight: 500;
  color: var(--tblr-body-color, #1e293b);
  margin: 0;
}

.audit-process-stage-field-value {
  font-size: 1.03rem;
  font-weight: 600;
  color: var(--tblr-body-color, #1e293b);
  min-height: 1.5rem;
  font-variant-numeric: tabular-nums;
}

.audit-process-stage-mandays-link {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 0.75rem;
  width: 100%;
  padding: 0;
  border: 0;
  background: transparent;
  text-align: left;
  cursor: pointer;
}

.audit-process-stage-mandays-link-hint {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  color: #16837d;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.015em;
  white-space: nowrap;
}

.audit-process-stage-mandays-link:hover .audit-process-stage-field-value,
.audit-process-stage-mandays-link:focus-visible .audit-process-stage-field-value {
  color: #0e7771;
  text-decoration: underline;
  text-decoration-thickness: 1px;
  text-underline-offset: 3px;
}

.audit-process-stage-mandays-link:focus-visible {
  outline: 2px solid #2a9d96;
  outline-offset: 4px;
  border-radius: 5px;
}

.audit-process-cid2-modal-content {
  overflow: hidden;
}

.audit-process-cid2-modal-content .modal-header {
  border-top: 3px solid #24a19c;
  align-items: flex-start;
}

.audit-process-cid2-modal-kicker {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  color: #16837d;
  font-size: 0.71rem;
  font-weight: 800;
  letter-spacing: 0.08em;
  text-transform: uppercase;
}

.audit-process-cid2-empty-state {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 1.1rem;
  border: 1px dashed #b9c8d7;
  border-radius: 12px;
  background: linear-gradient(135deg, #f7fbfc 0%, #f8fafc 100%);
}

.audit-process-cid2-empty-icon {
  display: grid;
  flex: 0 0 auto;
  width: 2.7rem;
  height: 2.7rem;
  place-items: center;
  border-radius: 10px;
  color: #64748b;
  background: #e7eef4;
}

@media (max-width: 520px) {
  .audit-process-stage-mandays-link {
    align-items: flex-start;
    flex-direction: column;
    gap: 0.2rem;
  }
}

.audit-process-stage-field-line {
  height: 2px;
  border-radius: 99px;
  background: linear-gradient(90deg, #c7d2e2 0%, #e2e8f0 100%);
}

.audit-process-stage-field-scope .audit-process-stage-field-value {
  font-weight: 400;
  font-size: 0.9rem;
  line-height: 1.45;
  min-height: 4rem;
}

.audit-process-stage-field-scope {
  border-color: #cfe2f6;
  background: linear-gradient(180deg, #f8fbff 0%, #f3f8ff 100%);
}

.audit-process-stage-scope-value {
  padding: 0.5rem 0.6rem;
  border: 1px solid var(--tblr-border-color, #e6e7e9);
  border-radius: 6px;
  background: var(--tblr-bg-surface-secondary, #f8f9fa);
  min-height: 4rem;
  white-space: pre-wrap;
  word-break: break-word;
}

.audit-process-stage-field-scope .audit-process-stage-field-line.scope-line {
  margin-top: 0.25rem;
}

.audit-process-stage-edit-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  font-weight: 500;
  color: #fff;
  background: #0d9488;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: background 0.15s ease;
}

.audit-process-stage-edit-btn:hover {
  background: #0f766e;
  color: #fff;
}

/* Documents nav */
.audit-process-doc-nav {
  display: flex;
  flex-direction: column;
}

.audit-process-doc-nav-item {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 0.75rem 1rem;
  border: none;
  background: transparent;
  text-align: left;
  font-size: 0.95rem;
  color: var(--tblr-body-color, #1e293b);
  cursor: pointer;
  transition: background 0.15s ease;
  border-radius: 0;
}

.audit-process-doc-nav-item:hover {
  background: var(--tblr-bg-surface-secondary, #f1f3f5);
}

.audit-process-doc-nav-item:focus-visible {
  outline: 2px solid #0d9488;
  outline-offset: -2px;
  z-index: 1;
}

.audit-process-doc-nav-item {
  border-left: 3px solid transparent;
}

.audit-process-doc-nav-item.active {
  background: rgba(13, 148, 136, 0.1);
  border-left-color: #0d9488;
  color: #0d9488;
  font-weight: 600;
}

.audit-process-doc-nav-check {
  flex-shrink: 0;
  color: #198754;
}

.audit-process-doc-nav-item.active .audit-process-doc-nav-check {
  color: #0d9488;
}

.audit-process-doc-section {
  border: 1px solid var(--tblr-border-color, #e6e7e9);
  border-radius: 8px;
  padding: 0.75rem;
  background: #ffffff;
}

/* CID revision/follow-up panel (Sales Pack tab) */
.audit-process-revision-card {
  display: flex;
  gap: 0.85rem;
  align-items: flex-start;
  border: 1px solid rgba(245, 159, 0, 0.35);
  border-left: 4px solid #f59f00;
  border-radius: 10px;
  padding: 1rem 1.1rem;
  background: linear-gradient(180deg, rgba(245, 159, 0, 0.06), rgba(245, 159, 0, 0.02));
}

.audit-process-revision-card__icon {
  flex-shrink: 0;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(245, 159, 0, 0.15);
  color: #b76e00;
}

.audit-process-revision-card__body {
  flex: 1 1;
  min-width: 0;
}

.audit-process-revision-card__title {
  font-weight: 600;
  font-size: 0.92rem;
  color: #7a4a00;
  margin-bottom: 0.2rem;
}

.audit-process-revision-card__assignee {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  border-radius: 999px;
  padding: 0.3rem 0.65rem;
  background: #e6f0fd;
  color: #1f5eab;
  font-size: 0.78rem;
  font-weight: 700;
}

.audit-process-revision-card__desc {
  font-size: 0.82rem;
  color: var(--tblr-secondary-color, #6b7280);
  margin-bottom: 0.75rem;
}

.audit-process-revision-card--success {
  border-color: rgba(45, 164, 78, 0.35);
  border-left-color: #2ba44e;
  background: linear-gradient(180deg, rgba(45, 164, 78, 0.08), rgba(45, 164, 78, 0.02));
}

.audit-process-revision-card--success .audit-process-revision-card__icon {
  background: rgba(45, 164, 78, 0.15);
  color: #2b8a3e;
}

.audit-process-revision-card--success .audit-process-revision-card__title {
  color: #206c3c;
}

/* Neutral "awaiting review" state (e.g. follow-up submitted, pending AR re-review) —
   teal to match the brand accent, distinct from the warning (orange) / success (green) tones. */
.audit-process-revision-card--info {
  border-color: rgba(31, 101, 108, 0.3);
  border-left-color: #1f656c;
  background: linear-gradient(180deg, rgba(31, 101, 108, 0.06), rgba(31, 101, 108, 0.02));
}

.audit-process-revision-card--info .audit-process-revision-card__icon {
  background: rgba(31, 101, 108, 0.12);
  color: #1f656c;
}

.audit-process-revision-card--info .audit-process-revision-card__title {
  color: #164c52;
}

.audit-process-revision-card__meta-list {
  list-style: none;
  margin: 0 0 0.75rem;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 0.3rem;
}

.audit-process-revision-card__meta-list li {
  font-size: 0.82rem;
  color: var(--tblr-body-color, #1e293b);
  background: rgba(0, 0, 0, 0.03);
  border-radius: 6px;
  padding: 0.35rem 0.6rem;
}

.audit-process-revision-card__hint {
  font-size: 0.78rem;
  color: var(--tblr-secondary-color, #6b7280);
  margin-top: 0.5rem;
}

.audit-process-revision-card__files {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 0.85rem;
}

.audit-process-revision-card__file-chip {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.4rem 0.75rem;
  border: 1px dashed rgba(245, 159, 0, 0.55);
  border-radius: 999px;
  background: #fff;
  color: #b76e00;
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}

.audit-process-revision-card__file-chip:hover {
  background: rgba(245, 159, 0, 0.08);
  border-color: #f59f00;
}

.audit-process-revision-card__file-chip.is-uploaded {
  border-style: solid;
  border-color: rgba(45, 164, 78, 0.5);
  background: rgba(45, 164, 78, 0.08);
  color: #2b8a3e;
}

.audit-process-revision-card__file-chip.is-uploaded:hover {
  background: rgba(45, 164, 78, 0.14);
  border-color: #2ba44e;
}

.audit-process-revision-card__footer {
  display: flex;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 0.5rem;
  padding-top: 0.6rem;
  border-top: 1px dashed rgba(245, 159, 0, 0.3);
}

.audit-process-revision-card--success .audit-process-revision-card__footer {
  border-top-color: rgba(45, 164, 78, 0.3);
}

.audit-process-revision-card--info .audit-process-revision-card__footer {
  border-top-color: rgba(31, 101, 108, 0.25);
}

/* "Need Revision" sits next to the primary "Mark Resolved" action -- kept neutral by default so
   it doesn't compete with the primary button, with a warning-tinted hover/focus so its intent
   (sending back for another round) is still legible before the click. */
.audit-process-revision-card__btn-ghost {
  color: #92600a;
  border-color: rgba(245, 159, 0, 0.4);
  background: #fff;
}

.audit-process-revision-card__btn-ghost:hover:not(:disabled),
.audit-process-revision-card__btn-ghost:focus-visible:not(:disabled) {
  color: #7a4a00;
  background: rgba(245, 159, 0, 0.1);
  border-color: #f59f00;
}

.audit-process-revision-card__btn-ghost:disabled {
  color: var(--tblr-secondary-color, #9aa4b2);
  border-color: var(--tblr-border-color, #dfe3e8);
  background: #fff;
}

.audit-process-doc-section-title {
  font-weight: 600;
  font-size: 0.95rem;
  color: var(--tblr-body-color, #1e293b);
  margin-bottom: 0.35rem;
}

.audit-process-doc-group {
  margin-top: 0.5rem;
}

.audit-process-doc-group-title {
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  color: #64748b;
  margin-bottom: 0.35rem;
}

.audit-process-doc-file-list {
  border: 1px solid var(--tblr-border-color, #e6e7e9);
  border-radius: 8px;
  overflow: hidden;
}

.audit-process-doc-file-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  padding: 0.6rem 0.75rem;
  background: #f8fafc;
  border-bottom: 1px solid var(--tblr-border-color, #e6e7e9);
}

.audit-process-doc-file-row:last-child {
  border-bottom: none;
}

.audit-process-doc-file-meta {
  min-width: 0;
  flex: 1 1;
}

.audit-process-doc-file-name {
  display: block;
  font-weight: 500;
  color: #334155;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.audit-process-doc-file-actions {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
}

.audit-process-doc-icon-btn {
  width: 32px;
  height: 32px;
  border: none;
  border-radius: 8px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #eef2ff;
  color: #2563eb;
  cursor: pointer;
  transition: background 0.15s ease, color 0.15s ease, transform 0.15s ease;
}

.audit-process-doc-icon-btn:hover {
  background: #dbeafe;
  color: #1d4ed8;
  transform: translateY(-1px);
}

.audit-process-doc-preview-frame {
  width: 100%;
  height: min(76vh, 820px);
  border: 0;
  background: #f8fafc;
}

.audit-process-preview-state {
  min-height: 420px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.75rem;
  padding: 2rem;
}

.audit-process-output-template-card {
  border: 1px solid #dbeafe;
  border-radius: 16px;
  padding: 16px;
  background: linear-gradient(180deg, #f8fbff 0%, #ffffff 100%);
}

/* The certificate preview sits directly under the FTRD-02 form, which is teal
   (--audit-accent #1a767e). This card used to be blue (#dbeafe border, blue
   shadow), so the column read as two unrelated surfaces stacked on top of each
   other. Retuned onto the same teal ramp as the form shell. */
.audit-process-inline-certificate-preview-card {
  border: 1px solid rgba(26, 118, 126, 0.2);
  border-radius: var(--audit-r-card);
  box-shadow: 0 14px 34px rgba(15, 89, 98, 0.07);
  background: linear-gradient(180deg, #f8fcfc 0%, #ffffff 100%);
}

/* This card lives outside .audit-form-shell, so it does not inherit the shell's
   button radius -- restate it here so the Preview/Download/Issue row matches
   the FTRD-02 form's own footer buttons directly above it. */
.audit-process-inline-certificate-preview-card .btn,
.audit-process-inline-certificate-preview-card .alert,
.audit-process-inline-certificate-preview-card .badge {
  border-radius: var(--audit-r-button);
}

/* Grouped (multi-standard) certificate issuance: one tab per standard.
   Tabler's default --tblr-nav-link-color is white, which makes inactive tabs
   invisible on the white card, so the colors are set explicitly here. */
.audit-process-certificate-standard-tabs .nav-tabs .nav-link {
  color: #475569;
  background: transparent;
  border-color: transparent;
  border-radius: var(--audit-r-input) var(--audit-r-input) 0 0;
  font-weight: 600;
  opacity: 1;
}

/* Accent matches the form shell's --audit-accent (#1a767e), not the slightly
   different teal these tabs used to carry (#0f766e) — the tabs, the form below
   them and the preview card are one surface and must read as one hue. */
.audit-process-certificate-standard-tabs .nav-tabs .nav-link:hover,
.audit-process-certificate-standard-tabs .nav-tabs .nav-link:focus {
  color: #1a767e;
  background: rgba(26, 118, 126, 0.08);
  border-color: transparent;
}

.audit-process-certificate-standard-tabs .nav-tabs .nav-link.active {
  color: #1a767e;
  background: #ffffff;
  border-color: var(--tblr-border-color, #e6e7e9) var(--tblr-border-color, #e6e7e9) transparent;
}

.audit-process-inline-certificate-preview-stage {
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow: auto;
  padding-bottom: 6px;
}

/* Audit Contact */
.audit-process-contact-block {
  border-top: 1px solid var(--tblr-border-color, #e6e7e9);
  padding-top: 1rem;
  margin-top: 1rem;
}

.audit-process-contact-block:first-child {
  border-top: none;
  padding-top: 0;
  margin-top: 0;
}

.audit-process-contact-block-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}

.audit-process-contact-block-title {
  font-size: 1.05rem;
  font-weight: 700;
  color: #1f2937;
}

.audit-process-contact-sameas {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  color: #334155;
  font-size: 0.95rem;
  font-weight: 500;
}

.audit-process-contact-sameas input {
  width: 18px;
  height: 18px;
  accent-color: #0d9488;
}

.audit-process-contact-grid {
  display: grid;
  grid-template-columns: 220px 16px 1fr;
  row-gap: 0.65rem;
  column-gap: 0.45rem;
  align-items: center;
}

.audit-process-contact-label {
  font-size: 0.95rem;
  font-weight: 600;
  color: #374151;
}

.audit-process-contact-colon {
  font-weight: 700;
  color: #64748b;
  text-align: center;
}

.audit-process-contact-input-wrap {
  display: flex;
  flex-direction: column;
}

.audit-process-contact-input {
  min-height: 2.4rem;
}

.audit-process-contact-input:disabled {
  background: #f1f5f9;
}

.audit-process-contact-value {
  min-height: 2.8rem;
  padding: 0.55rem 0.8rem;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #f1f5f9;
  color: #334155;
  font-size: 0.95rem;
  font-weight: 600;
  display: flex;
  align-items: center;
}

/* Checklist */
.audit-process-checklist {
  margin: 0 0 1rem 0;
  padding: 0;
}

.audit-process-checklist-item {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.75rem;
  padding: 0.6rem 0;
  border-bottom: 1px solid var(--tblr-border-color-translucent, rgba(0, 0, 0, 0.06));
}

.audit-process-checklist-item:last-of-type {
  border-bottom: none;
}

.audit-process-checklist-num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 1.75rem;
  width: 1.75rem;
  height: 1.75rem;
  font-weight: 600;
  font-size: 0.875rem;
  color: var(--tblr-primary, #206bc4);
  background: rgba(32, 107, 196, 0.1);
  border: 1px solid var(--tblr-primary, #206bc4);
  border-radius: 50%;
}

.audit-process-checklist-view-btn {
  color: var(--tblr-primary, #206bc4);
  background: rgba(32, 107, 196, 0.1);
  border: 1px solid var(--tblr-primary, #206bc4);
}

.audit-process-checklist-view-btn:hover {
  color: #fff;
  background: var(--tblr-primary, #206bc4);
}

.audit-process-checklist-label {
  flex: 1 1;
  min-width: 80px;
}

.audit-process-checklist-options {
  display: flex;
  align-items: center;
  gap: 1.25rem;
}

.audit-process-checklist-notes {
  width: 100%;
  flex-basis: 100%;
  margin-left: 0;
  padding-left: calc(1.5rem + 0.75rem);
}

.audit-process-checklist-notes .form-label {
  margin-bottom: 0.35rem;
}

.audit-process-radio-ok,
.audit-process-radio-revisi {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  cursor: pointer;
  font-size: 0.9rem;
  margin: 0;
  padding: 0.4rem 0.75rem;
  border-radius: 6px;
  border: 1px solid var(--tblr-border-color, #e6e7e9);
  background: transparent;
  color: var(--tblr-secondary, #6c757d);
  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;
}

.audit-process-radio-ok input,
.audit-process-radio-revisi input {
  width: 1.1rem;
  height: 1.1rem;
  accent-color: #0d9488;
}

.audit-process-radio-ok.is-selected {
  background: rgba(25, 135, 84, 0.12);
  border-color: #198754;
  color: #198754;
}

.audit-process-radio-ok input {
  accent-color: #198754;
}

.audit-process-radio-revisi.is-selected {
  background: rgba(220, 53, 69, 0.12);
  border-color: #dc3545;
  color: #dc3545;
}

.audit-process-radio-revisi input {
  accent-color: #dc3545;
}

.audit-process-notes {
  resize: vertical;
  min-height: 80px;
  border-radius: 6px;
}

.audit-process-btn-revision {
  border-color: #dc3545;
  color: #dc3545;
  border-radius: 6px;
}

.audit-process-btn-revision:hover {
  background: rgba(220, 53, 69, 0.1);
  border-color: #dc3545;
  color: #dc3545;
}

.audit-process-btn-continue {
  border-radius: 6px;
}

/* Badges (if not in theme) */
.bg-success-lt {
  background: rgba(25, 135, 84, 0.15);
}

.text-success {
  color: #198754 !important;
}

.bg-warning-lt {
  background: rgba(255, 193, 7, 0.2);
}

.text-warning {
  color: #b8860b !important;
}

/* Project History timeline */
.audit-process-timeline {
  position: relative;
  padding-left: 1.5rem;
}

.audit-process-timeline-item {
  position: relative;
  padding-bottom: 1.25rem;
}

.audit-process-timeline-item:last-child {
  padding-bottom: 0;
}

.audit-process-timeline-marker {
  position: absolute;
  left: -1.5rem;
  top: 0.4rem;
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #0d9488;
  border: 2px solid #fff;
  box-shadow: 0 0 0 1px #0d9488;
}

.audit-process-timeline-item::before {
  content: '';
  position: absolute;
  left: -1.125rem;
  top: 1.25rem;
  bottom: -0.5rem;
  width: 2px;
  background: rgba(13, 148, 136, 0.35);
}

.audit-process-timeline-item:last-child::before {
  display: none;
}

.audit-process-timeline-content strong {
  display: block;
  margin-bottom: 0.15rem;
}

.audit-process-timeline-content p {
  font-size: 0.875rem;
}

/* Confirmation modal – icon on top, no title bar */
.audit-process-confirm-modal-content .modal-header {
  justify-content: flex-end;
}

.audit-process-confirm-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 3.25rem;
  height: 3.25rem;
  border-radius: 50%;
  margin-bottom: 1rem;
}

.audit-process-confirm-icon-danger {
  background: #dc3545;
  color: #fff;
  box-shadow: 0 0 0 4px rgba(220, 53, 69, 0.25);
}

.audit-process-confirm-icon-warning {
  background: #ffc107;
  color: #fff;
  box-shadow: 0 0 0 4px rgba(255, 193, 7, 0.35);
}

.audit-process-confirm-icon-success {
  background: #22c55e;
  color: #fff;
  box-shadow: 0 0 0 4px rgba(34, 197, 94, 0.25);
}

.audit-process-confirm-title {
  font-weight: 600;
  color: var(--tblr-body-color, #1e293b);
  font-size: 1.1rem;
}

.audit-process-confirm-body {
  font-size: 0.9375rem;
  line-height: 1.5;
}

/* Scheduling */
.audit-process-scheduling-subtabs {
  display: flex;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.audit-process-scheduling-wizard {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 0.5rem;
  padding: 0.65rem;
  border: 1px solid #dce8e8;
  border-radius: 0.75rem;
  background: linear-gradient(135deg, #f7fbfb, #eef7f6);
}

.audit-process-scheduling-wizard-step {
  min-height: 3.25rem;
  display: flex;
  align-items: center;
  gap: 0.55rem;
  padding: 0.6rem 0.7rem;
  border: 1px solid transparent;
  border-radius: 0.6rem;
  background: transparent;
  color: #5f7075;
  font-size: 0.77rem;
  font-weight: 600;
  text-align: left;
  transition: border-color 160ms ease, background-color 160ms ease, color 160ms ease;
}

.audit-process-scheduling-wizard-step:hover,
.audit-process-scheduling-wizard-step:focus-visible {
  border-color: #83c9c5;
  outline: none;
}

.audit-process-scheduling-wizard-step.active {
  border-color: #2ca8a1;
  background: #fff;
  color: #146d69;
  box-shadow: 0 5px 14px rgba(30, 115, 111, 0.1);
}

.audit-process-scheduling-wizard-step.completed {
  color: #27843f;
}

.audit-process-scheduling-wizard-index {
  width: 1.65rem;
  height: 1.65rem;
  flex: 0 0 1.65rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background: #dbe7e7;
  font-size: 0.72rem;
}

.audit-process-scheduling-wizard-step.active .audit-process-scheduling-wizard-index {
  background: #1f8e88;
  color: #fff;
}

.audit-process-scheduling-wizard-step.completed .audit-process-scheduling-wizard-index {
  background: #dff4e3;
  color: #27843f;
}

.audit-process-scheduling-status {
  display: inline-flex;
  align-items: center;
  border-radius: 999px;
  padding: 0.35rem 0.7rem;
  background: #edf1f2;
  color: #59686d;
  font-size: 0.75rem;
  font-weight: 700;
}

.audit-process-scheduling-status-confirmed { background: #dcf5e3; color: #25783b; }
.audit-process-scheduling-status-in-progress { background: #fff1cf; color: #99670d; }

.audit-process-scheduling-assignee {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  border-radius: 999px;
  padding: 0.35rem 0.7rem;
  background: #e6f0fd;
  color: #1f5eab;
  font-size: 0.75rem;
  font-weight: 700;
}

.audit-process-scheduling-assignee strong {
  font-weight: 700;
}

.audit-process-review-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 0.75rem;
}

.audit-process-review-metric {
  min-height: 8rem;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  padding: 1rem;
  border: 1px solid #dce8e8;
  border-top: 3px solid #2ca8a1;
  border-radius: 0.65rem;
  background: #fff;
}

.audit-process-review-metric span { color: #708086; font-size: 0.72rem; text-transform: uppercase; letter-spacing: 0.04em; }
.audit-process-review-metric strong { color: #173f42; font-size: 1.55rem; }
.audit-process-review-metric small { color: #657579; line-height: 1.35; }

.audit-process-wizard-actions {
  display: flex;
  justify-content: space-between;
  padding-top: 1rem;
  border-top: 1px solid #e3ebec;
}

.audit-process-wizard-saved-flash {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 0.8rem;
  font-weight: 600;
  color: #15803d;
}

@media (max-width: 991.98px) {
  .audit-process-scheduling-wizard { grid-template-columns: 1fr; }
  .audit-process-scheduling-wizard-step { min-height: 2.75rem; }
  .audit-process-review-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}

@media (max-width: 575.98px) {
  .audit-process-review-grid { grid-template-columns: 1fr; }
}

.audit-process-scheduling-toolbar {
  border: 1px solid #dbe3ec;
  border-radius: 10px;
  padding: 0.8rem;
  background: #f8fafc;
}

.audit-process-scheduling-lock {
  display: flex;
  align-items: flex-start;
  gap: 0.75rem;
  margin-bottom: 1rem;
  padding: 0.875rem 1rem;
  color: #6b4b0f;
  background: linear-gradient(135deg, #fff9e8 0%, #fff4cf 100%);
  border: 1px solid #e9c96c;
  border-left: 4px solid #c28a18;
  border-radius: 0.65rem;
}

.audit-process-scheduling-lock__icon {
  display: inline-grid;
  place-items: center;
  flex: 0 0 2rem;
  width: 2rem;
  height: 2rem;
  color: #8d650e;
  background: rgba(255, 255, 255, 0.75);
  border-radius: 50%;
}

.audit-process-scheduling-lock p {
  margin-top: 0.15rem;
  color: #7b5b1d;
  font-size: 0.82rem;
  line-height: 1.45;
}

.audit-process-scheduling-subtab {
  border: 1px solid #d1d5db;
  background: #ffffff;
  color: #374151;
  border-radius: 8px;
  padding: 0.45rem 0.8rem;
  font-weight: 600;
  font-size: 0.9rem;
}

.audit-process-scheduling-subtab.active {
  border-color: #0d9488;
  color: #0f766e;
  background: #ecfeff;
}

.audit-process-scheduling-card {
  border: 1px solid #dbe3ec;
  border-radius: 10px;
  overflow: hidden;
  background: #ffffff;
}

.audit-process-scheduling-card-date-picker {
  overflow: visible;
  position: relative;
}

.audit-process-scheduling-card-header {
  padding: 0.75rem 1rem;
  background: #f8fafc;
  border-bottom: 1px solid #e5e7eb;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.audit-process-scheduling-card-header h5 {
  font-size: 1rem;
  font-weight: 700;
  color: #334155;
}

.audit-process-scheduling-card-body {
  padding: 1rem;
}

.audit-process-add-auditor-bottom {
  position: sticky;
  bottom: 0;
  z-index: 3;
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
  margin-top: 0.75rem;
  padding: 0.65rem 0;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 38%);
}

.audit-process-save-warning-label {
  margin-right: auto;
  display: inline-flex;
  align-items: center;
  padding: 0.42rem 0.7rem;
  border-radius: 8px;
  border: 1px solid #f59e0b;
  background: #fffbeb;
  color: #b45309;
  font-size: 0.82rem;
  font-weight: 700;
  line-height: 1.2;
}

.audit-process-scheduling-action-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.35rem;
  min-height: 2.5rem;
  border-radius: 10px;
  font-weight: 700;
  letter-spacing: 0.01em;
  padding: 0.48rem 1rem;
  transition-property: color, background-color, background-image, border-color, box-shadow;
  transition-duration: 0.16s;
  transition-timing-function: ease;
}

.audit-process-scheduling-action-btn-primary {
  color: #ffffff;
  border: 1px solid #0f766e;
  background: linear-gradient(135deg, #14b8a6 0%, #0d9488 100%);
  box-shadow: 0 4px 12px rgba(13, 148, 136, 0.22);
}

.audit-process-scheduling-action-btn-primary:hover:not(:disabled) {
  color: #ffffff;
  border-color: #0f766e;
  background: linear-gradient(135deg, #0d9488 0%, #0f766e 100%);
  box-shadow: 0 6px 16px rgba(13, 148, 136, 0.28);
  transform: translateY(-1px);
}

.audit-process-scheduling-action-btn-secondary {
  color: #0f766e;
  border: 1px solid #5eead4;
  background: #f0fdfa;
}

.audit-process-scheduling-action-btn-secondary:hover:not(:disabled) {
  color: #0f766e;
  border-color: #2dd4bf;
  background: #ccfbf1;
  transform: translateY(-1px);
}

.audit-process-scheduling-action-btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
  transform: none;
}

.audit-process-mandays-total-label {
  display: inline-flex;
  align-items: center;
  padding: 0.22rem 0.6rem;
  border-radius: 999px;
  background: #e6fffb;
  border: 1px solid #99f6e4;
  color: #0f766e;
  font-size: 0.78rem;
  font-weight: 700;
  line-height: 1.2;
}

.audit-process-site-chip-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
}

.audit-process-site-chip {
  display: inline-flex;
  align-items: center;
  padding: 0.24rem 0.55rem;
  border-radius: 999px;
  border: 1px solid #bae6fd;
  color: #0369a1;
  background: #f0f9ff;
  font-size: 0.8rem;
  font-weight: 600;
}

.audit-process-site-options {
  border: 1px solid #dbe3ec;
  border-radius: 8px;
  padding: 0.55rem;
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 0.45rem;
}

.audit-process-site-option {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
  font-size: 0.9rem;
  color: #334155;
}

.audit-process-linked-auditors {
  margin-top: 0.25rem;
}

.audit-process-linked-auditor-item-legacy {
  padding: 0.6rem 0.75rem;
  display: grid;
  grid-template-columns: 1.2fr 0.8fr 0.8fr;
  gap: 0.6rem;
  border-bottom: 1px solid #e5e7eb;
  font-size: 0.9rem;
  color: #334155;
}

.audit-process-linked-auditor-item-legacy:last-child {
  border-bottom: none;
}

.audit-process-accommodation-box {
  border: 1px solid #dbe3ec;
  border-radius: 8px;
  overflow: hidden;
}

.audit-process-accommodation-box-header {
  background: #f8fafc;
  border-bottom: 1px solid #e5e7eb;
  padding: 0.6rem 0.85rem;
  font-weight: 700;
  font-size: 0.9rem;
  color: #334155;
}

.audit-process-accommodation-box-body {
  padding: 0.85rem;
}

.audit-process-uploaded-list {
  border: 1px solid #dbe3ec;
  border-radius: 8px;
  overflow: hidden;
}

.audit-process-uploaded-item {
  padding: 0.5rem 0.7rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #e5e7eb;
}

.audit-process-uploaded-item:last-child {
  border-bottom: none;
}

.audit-process-accommodation-schedule-select {
  border-color: #99f6e4;
  background: #f8fffe;
}

.audit-process-accommodation-schedule-select:focus {
  border-color: #14b8a6;
  box-shadow: 0 0 0 3px rgba(20, 184, 166, 0.16);
}

.audit-process-accommodation-schedule-preview {
  display: flex;
  flex-direction: column;
  gap: 0.6rem;
}

.audit-process-accommodation-schedule-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.audit-process-accommodation-schedule-meta {
  display: flex;
  gap: 0.4rem;
  flex-wrap: wrap;
}

.audit-process-accommodation-date-actions {
  display: flex;
  justify-content: flex-end;
}

.audit-process-accommodation-date-grid {
  gap: 0.45rem;
}

.audit-process-accommodation-date-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0.3rem 0.7rem;
  border-radius: 999px;
  border: 1px solid #99f6e4;
  background: #ecfeff;
  color: #0f766e;
  font-size: 0.78rem;
  font-weight: 700;
  letter-spacing: 0.01em;
  transition-property: color, background-color, background-image, border-color, box-shadow;
  transition-duration: 0.16s;
  transition-timing-function: ease;
}

.audit-process-accommodation-date-pill:hover {
  border-color: #14b8a6;
  background: #d9fffb;
}

.audit-process-accommodation-date-pill.active {
  border-color: #0d9488;
  background: linear-gradient(135deg, #14b8a6 0%, #0d9488 100%);
  color: #ffffff;
  box-shadow: 0 3px 8px rgba(13, 148, 136, 0.26);
}

@keyframes audit-process-shimmer {
  0%,
  100% {
    transform: translateX(-130%) rotate(25deg);
    opacity: 0;
  }
  18% {
    opacity: 0;
  }
  42% {
    opacity: 0.95;
  }
  62% {
    transform: translateX(280%) rotate(25deg);
    opacity: 0;
  }
}

@media (prefers-reduced-motion: reduce) {
  .audit-process-stage-item.is-expanded::after,
  .audit-process-inline-major-item.is-current::after {
    animation: none;
  }
}

@media (max-width: 768px) {
  .audit-process-header-inner {
    flex-direction: column;
    align-items: flex-start;
  }

  .audit-process-inline-stepper {
    padding: 0.7rem;
  }

  .audit-process-inline-major-item {
    min-width: 150px;
  }

  .audit-process-contact-grid {
    grid-template-columns: 1fr;
    row-gap: 0.35rem;
  }

  .audit-process-contact-colon {
    display: none;
  }

  .audit-process-contact-label {
    margin-top: 0.2rem;
  }

  .audit-process-linked-auditor-item {
    flex-direction: column;
    align-items: flex-start;
  }

  .audit-process-calendar-picker {
    width: 94vw;
    min-width: 0;
    max-width: 94vw;
    max-height: 85vh;
    padding: 0.85rem;
  }

  .audit-process-calendar-picker .calendar-month-header h6 {
    min-width: 120px;
  }

  .audit-process-calendar-picker .calendar-grid {
    gap: 0.2rem;
  }

  .calendar-day {
    font-size: 0.75rem;
    min-height: 38px;
  }

  .audit-process-selected-dates {
    flex-direction: column;
    align-items: flex-start;
  }

  .audit-process-date-badge {
    width: 100%;
    justify-content: center;
  }

  .audit-process-date-selection-panel {
    grid-template-columns: 1fr;
    padding: 0.7rem;
  }

  .audit-process-date-picker-trigger {
    min-height: 2.75rem;
    font-size: 0.92rem;
    border-radius: 9px;
  }

  .audit-process-date-picker-count {
    margin-top: 0.35rem;
    font-size: 0.84rem;
  }

  .audit-process-date-selection-preview .audit-process-selected-dates {
    max-height: none;
    overflow: visible;
    padding-right: 0;
  }

  .audit-process-add-auditor-bottom {
    flex-direction: column;
    justify-content: stretch;
  }

  .audit-process-add-auditor-bottom .btn {
    width: 100%;
  }

  .audit-process-save-warning-label {
    width: 100%;
    margin-right: 0;
    justify-content: center;
    text-align: center;
  }

  .audit-process-scheduling-action-btn {
    width: 100%;
  }

  .audit-process-accommodation-schedule-head {
    align-items: flex-start;
  }

  .audit-process-accommodation-date-actions {
    justify-content: flex-start;
  }
}

/* ── Manday + Site combined row ───────────────────────────────── */
.audit-process-manday-site-row {
  background: linear-gradient(135deg, #f8fafc 0%, #f0fdfa 100%);
  border: 1px solid #d1fae5 !important;
  border-left: 3px solid #14b8a6 !important;
  border-radius: 10px;
  padding: 0.85rem 1rem;
  transition: box-shadow 0.18s ease, border-color 0.18s ease;
}

.audit-process-manday-site-row:hover {
  box-shadow: 0 2px 10px rgba(20, 184, 166, 0.1);
  border-color: #a7f3d0 !important;
  border-left-color: #0d9488 !important;
}

.audit-process-manday-site-row .form-control-sm {
  background: #ffffff;
  border-color: #d1d5db;
}

/* ── Site selection pill toggle buttons ───────────────────────── */
.audit-process-site-pills-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  align-items: center;
}

.audit-process-site-pill {
  display: inline-flex;
  align-items: center;
  padding: 0.3rem 0.75rem;
  border-radius: 999px;
  border: 1.5px solid #cbd5e1;
  background: #ffffff;
  color: #475569;
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  transition-property: color, background-color, background-image, border-color, box-shadow;
  transition-duration: 0.15s;
  transition-timing-function: ease;
  white-space: nowrap;
  -webkit-user-select: none;
          user-select: none;
  line-height: 1.4;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.audit-process-site-pill:hover:not(:disabled) {
  border-color: #14b8a6;
  color: #0f766e;
  background: #f0fdfa;
  box-shadow: 0 1px 5px rgba(20, 184, 166, 0.18);
}

.audit-process-site-pill.active {
  background: linear-gradient(135deg, #14b8a6 0%, #0d9488 100%);
  border-color: #0d9488;
  color: #ffffff;
  box-shadow: 0 2px 6px rgba(13, 148, 136, 0.35);
}

.audit-process-site-pill.active:hover:not(:disabled) {
  background: linear-gradient(135deg, #0d9488 0%, #0f766e 100%);
  border-color: #0f766e;
}

.audit-process-site-pill:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

/* ── Site Location tab: auditor + date display ────────────────── */
.audit-process-linked-auditors {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  background: #ffffff;
}

.audit-process-linked-auditor-item {
  padding: 0.65rem 0.85rem;
  display: flex;
  flex-direction: column;
  gap: 0.35rem;
  border-bottom: 1px solid #f1f5f9;
  font-size: 0.9rem;
}

.audit-process-linked-auditor-item:last-child {
  border-bottom: none;
}

.audit-process-linked-auditor-name {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.audit-process-linked-auditor-type {
  display: inline-flex;
  align-items: center;
  padding: 0.15rem 0.5rem;
  border-radius: 6px;
  background: #f1f5f9;
  color: #64748b;
  font-size: 0.75rem;
  font-weight: 500;
}

.audit-process-auditor-dates {
  display: flex;
  flex-wrap: wrap;
  gap: 0.35rem;
}

.audit-process-auditor-date-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.18rem 0.55rem;
  border-radius: 6px;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  color: #1d4ed8;
  font-size: 0.73rem;
  font-weight: 500;
  font-variant-numeric: tabular-nums;
  letter-spacing: 0.01em;
}

/* ── Date Range Picker ───────────────────────────────────────── */
.audit-process-date-range-picker-wrapper {
  position: relative;
  z-index: 5;
}

.audit-process-date-selection-panel {
  display: grid;
  grid-template-columns: minmax(280px, 1fr) minmax(260px, 1fr);
  gap: 0.8rem;
  align-items: start;
  padding: 0.85rem;
  border: 1px solid #d1fae5;
  border-radius: 12px;
  background: linear-gradient(145deg, #f8fafc 0%, #f0fdfa 100%);
}

.audit-process-date-picker-trigger {
  width: 100%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 3rem;
  padding: 0.5rem 0.85rem;
  border: 1px solid #99f6e4;
  border-radius: 10px;
  background: #ffffff;
  color: #0f766e;
  font-size: 1rem;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: 0.02em;
  text-transform: uppercase;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
}

.audit-process-date-picker-count {
  margin-top: 0.45rem;
  font-size: 0.9rem;
  font-weight: 600;
  color: #475569;
}

.audit-process-date-picker-trigger:hover {
  border-color: #14b8a6;
  background: #f0fdfa;
}

.audit-process-date-picker-trigger:focus-visible {
  outline: none;
  border-color: #0d9488;
  box-shadow: 0 0 0 3px rgba(13, 148, 136, 0.2);
}

.audit-process-date-selection-preview {
  display: flex;
  flex-direction: column;
  gap: 0.45rem;
  min-width: 0;
}

.audit-process-selected-dates-title {
  font-size: 0.78rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #0f766e;
}

.audit-process-calendar-picker {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  padding: 1rem;
  margin-top: 0;
  box-shadow: 0 20px 48px rgba(15, 23, 42, 0.2);
  z-index: 1060;
  width: min(92vw, 440px);
  min-width: 320px;
  max-width: 92vw;
  display: flex;
  flex-direction: column;
  max-height: 82vh;
  overflow-y: auto;
}

.audit-process-calendar-picker .calendar-month-header {
  text-align: center;
  margin-bottom: 0.75rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid #f1f5f9;
  font-weight: 600;
  color: #1f2937;
  font-size: 0.95rem;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.audit-process-calendar-picker .calendar-month-header .btn-link {
  color: #64748b;
  text-decoration: none;
  font-size: 1.2rem;
  line-height: 1;
}

.audit-process-calendar-picker .calendar-month-header .btn-link:hover {
  color: #14b8a6;
}

.audit-process-calendar-picker .calendar-weekdays {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 0.2rem;
  margin-bottom: 0.5rem;
  text-align: center;
  flex-shrink: 0;
}

.audit-process-calendar-picker .calendar-weekdays div {
  font-size: 0.7rem;
  font-weight: 600;
  color: #6b7280;
  padding: 0.35rem 0;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.audit-process-calendar-picker .calendar-grid {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 0.25rem;
  margin-bottom: 0.75rem;
  flex-grow: 1;
}

.calendar-day {
  aspect-ratio: 1;
  padding: 0;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: #ffffff;
  color: #1f2937;
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  transition-property: color, background-color, border-color;
  transition-duration: 0.15s;
  transition-timing-function: ease;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 40px;
}

.calendar-day:hover:not(:disabled) {
  border-color: #14b8a6;
  background: #f0fdfa;
  color: #0d9488;
}

.calendar-day.other-month {
  color: #d1d5db;
  background: #f9fafb;
  cursor: not-allowed;
}

.calendar-day.availability-half {
  background: #fff7ed;
  border-color: #fb923c;
  color: #9a3412;
}

.calendar-day.availability-full {
  background: #fef2f2;
  border-color: #ef4444;
  color: #b91c1c;
  font-weight: 700;
}

.calendar-day.availability-half:hover:not(:disabled),
.calendar-day.availability-full:hover:not(:disabled) {
  filter: brightness(0.97);
}

.calendar-day.selected {
  background: linear-gradient(135deg, #14b8a6 0%, #0d9488 100%);
  border-color: #0d9488;
  color: #ffffff;
  font-weight: 600;
  box-shadow: 0 2px 6px rgba(13, 148, 136, 0.35);
}

.calendar-day.selected:hover {
  box-shadow: 0 4px 10px rgba(13, 148, 136, 0.45);
}

.calendar-availability-legend {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.65rem;
  margin: 0 0 0.65rem;
  font-size: 0.72rem;
}

.calendar-availability-legend span {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
}

.calendar-availability-swatch {
  width: 0.7rem;
  height: 0.7rem;
  border-radius: 3px;
  border: 1px solid transparent;
}

.calendar-availability-swatch.half {
  background: #fff7ed;
  border-color: #fb923c;
}

.calendar-availability-swatch.full {
  background: #fef2f2;
  border-color: #ef4444;
}

.calendar-day:disabled {
  cursor: not-allowed;
}

.audit-process-calendar-picker .calendar-actions {
  display: flex;
  gap: 0.5rem;
  justify-content: flex-end;
  padding-top: 0.75rem;
  border-top: 1px solid #f1f5f9;
  flex-shrink: 0;
}

.audit-process-calendar-picker .calendar-actions button {
  min-width: 80px;
  font-weight: 500;
}

.audit-process-calendar-picker .calendar-actions .badge {
  font-weight: 600;
  font-size: 0.7rem;
  padding: 0.25rem 0.45rem;
}

/* ── Selected dates display ──────────────────────────────────── */
.audit-process-selected-dates {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  align-items: center;
}

.audit-process-date-badge {
  display: inline-flex;
  align-items: center;
  padding: 0.35rem 0.8rem;
  border-radius: 20px;
  background: linear-gradient(135deg, #14b8a6 0%, #0d9488 100%);
  color: #ffffff;
  font-size: 0.8rem;
  font-weight: 600;
  letter-spacing: 0.02em;
  box-shadow: 0 2px 8px rgba(13, 148, 136, 0.28);
  white-space: nowrap;
}

.audit-process-date-badge:hover {
  box-shadow: 0 4px 12px rgba(13, 148, 136, 0.38);
}

.audit-process-date-selection-preview .audit-process-selected-dates {
  max-height: 8.5rem;
  overflow-y: auto;
  padding-right: 0.2rem;
}

/* Shared Audit Scope selector. This wrapper is deliberately local to the
   Audit Process page: proposal scope may populate information fields, while
   this explicit selector remains the source of the active workflow context. */
.audit-process-scope-selector {
  position: relative;
  padding: 0.9rem 1rem 1rem;
  border: 1px solid #b9dcd9;
  border-radius: 12px;
  background: linear-gradient(135deg, #f8fffe 0%, #f2fbfa 100%);
  box-shadow: 0 7px 20px rgba(15, 118, 110, 0.07);
  transition: border-color 160ms ease, box-shadow 160ms ease, background 160ms ease;
}

.audit-process-scope-selector.is-pending {
  border-color: #f59e0b;
  background: linear-gradient(135deg, #fffdf5 0%, #fff8e8 100%);
  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.1), 0 8px 22px rgba(146, 93, 8, 0.08);
}

.audit-process-scope-selector.is-selected:focus-within {
  border-color: #0f8f83;
  box-shadow: 0 0 0 3px rgba(15, 143, 131, 0.13), 0 8px 24px rgba(15, 118, 110, 0.1);
}

.audit-process-scope-selector__prompt {
  display: flex;
  align-items: flex-start;
  gap: 0.45rem;
  margin-bottom: 0.65rem;
  color: #315e61;
  font-size: 0.75rem;
  line-height: 1.4;
}

.audit-process-scope-selector.is-pending .audit-process-scope-selector__prompt {
  color: #995d08;
}

.audit-process-scope-selector__prompt svg {
  flex: 0 0 auto;
  margin-top: 0.05rem;
}

.audit-process-scope-selector .form-label {
  margin-bottom: 0.4rem;
  color: #173f43;
  font-weight: 700;
}

.audit-process-scope-select {
  min-height: 44px;
  border: 1px solid #87c8c2;
  border-radius: 9px;
  color: #193b40;
  background-color: #fff;
  font-weight: 600;
  box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.03);
}

.audit-process-scope-select:hover,
.audit-process-scope-select:focus {
  border-color: #0f8f83;
  box-shadow: 0 0 0 0.2rem rgba(15, 143, 131, 0.12);
}

.audit-process-scope-selector__hint {
  display: block;
  margin-top: 0.45rem;
  color: #687d80;
  font-size: 0.7rem;
}

@media (max-width: 575.98px) {
  .audit-process-scope-selector { padding: 0.8rem; }
  .audit-process-scope-selector__prompt { font-size: 0.72rem; }
}

/* AP-012: ensure a clear dropdown caret on select fields inside the audit
   document form (Scheduling Scope, service item, etc.) so users can tell
   the field is a selectable dropdown. Scoped to the modal — no global impact. */
.audit-doc-form-modal .form-select {
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 0.55rem center;
  background-size: 14px 11px;
  padding-right: 2rem;
}

/* Integrated / Combined methodology group banner (#17) */
.audit-process-methodology-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.4rem;
  padding: 0.5rem 0.75rem;
  border: 1px dashed #99e0da;
  border-radius: 8px;
  background: #f3fbfa;
}

/* Point-4 auto-focus: scrollIntoView({block:'start'}) aligns this section's
   top edge with the viewport top. On mobile that lands directly behind the
   fixed .mobile-navbar (64px tall, position:fixed) -- the section's own
   heading would render hidden under it. scroll-margin-top reserves that
   space so the browser's native scroll-into-view (used by our own
   scrollIntoView call and by anchor/keyboard navigation alike) stops below
   the navbar instead of under it. */
@media (max-width: 991.98px) {
  .audit-process-primary-doc-section {
    scroll-margin-top: 76px;
  }
}

/* Point-4 (sticky mini-stepper): keeps Stage 1/2 + Review->Audit->TR->Certificate
   progress visible while the user scrolls past the full stepper card. Pure CSS
   \`position: sticky\` (same idiom as Analysis's \`.analysis-sticky-stack\`) -- no
   scroll-listener JS needed. Sits below the fixed .mobile-navbar (z-index 1030). */
.audit-process-sticky-stepper {
  position: sticky;
  top: 0;
  z-index: 900;
  margin: 0 0 1rem;
  padding: 0.5rem 0;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, rgba(255, 255, 255, 0.94) 82%, rgba(255, 255, 255, 0) 100%);
  backdrop-filter: blur(8px);
}

.audit-process-sticky-stepper-inner {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.55rem 0.9rem;
  border-radius: 12px;
  border: 1px solid #99e0da;
  background: linear-gradient(135deg, #0d3d42 0%, #1f656c 55%, #2a8a93 100%);
  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.14);
  overflow-x: auto;
  scrollbar-width: none;
}

.audit-process-sticky-stepper-inner::-webkit-scrollbar {
  display: none;
}

.audit-process-sticky-stepper-cycle {
  flex-shrink: 0;
  font-size: 0.78rem;
  font-weight: 700;
  color: #ecfeff;
  padding-right: 0.75rem;
  border-right: 1px solid rgba(255, 255, 255, 0.25);
  white-space: nowrap;
  max-width: 160px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.audit-process-sticky-stepper-cycle-badge {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  padding: 0.2rem 0.55rem;
  margin-right: 0.75rem;
  border-radius: 9999px;
  font-size: 0.72rem;
  font-weight: 700;
  color: #1d4ed8;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  white-space: nowrap;
}

.audit-process-sticky-stepper-steps {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  flex: 1 1;
  min-width: 0;
}

.audit-process-sticky-step {
  display: flex;
  align-items: center;
  gap: 0.35rem;
  flex-shrink: 0;
  opacity: 0.55;
}

.audit-process-sticky-step.is-completed {
  opacity: 0.85;
}

.audit-process-sticky-step.is-current {
  opacity: 1;
}

.audit-process-sticky-step-dot {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  font-size: 0.68rem;
  font-weight: 700;
  color: #ffffff;
  background: rgba(255, 255, 255, 0.18);
  border: 1px solid rgba(255, 255, 255, 0.35);
  flex-shrink: 0;
}

.audit-process-sticky-step.is-completed .audit-process-sticky-step-dot {
  background: #2dd4bf;
  border-color: #2dd4bf;
  color: #0d3d42;
}

.audit-process-sticky-step.is-current .audit-process-sticky-step-dot {
  background: #ffffff;
  border-color: #ffffff;
  color: #0d3d42;
}

.audit-process-sticky-step-label {
  font-size: 0.75rem;
  font-weight: 600;
  color: #ecfeff;
  white-space: nowrap;
}

.audit-process-sticky-step-divider {
  width: 14px;
  height: 1px;
  background: rgba(255, 255, 255, 0.3);
  flex-shrink: 0;
}

.audit-process-sticky-stepper-cert-btn {
  flex-shrink: 0;
  font-size: 0.75rem;
  font-weight: 700;
  color: #ffffff;
  background: #0d9488;
  border: none;
  padding: 0.35rem 0.85rem;
  border-radius: 999px;
  white-space: nowrap;
  text-decoration: none;
  cursor: pointer;
  transition: background-color 150ms ease;
}

.audit-process-sticky-stepper-cert-btn:hover {
  background: #0f766e;
  color: #ffffff;
}

.audit-process-sticky-stepper-cert-btn:focus-visible {
  outline: 2px solid #0d3d42;
  outline-offset: 2px;
}

.audit-process-sticky-stepper-cert-btn.is-disabled {
  background: #e2e8f0;
  color: #94a3b8;
  cursor: not-allowed;
}

@media (max-width: 991.98px) {
  .audit-process-sticky-stepper {
    top: 64px;
  }

  .audit-process-sticky-stepper-cycle {
    max-width: 110px;
  }

  .audit-process-sticky-step-label {
    display: none;
  }

  .audit-process-sticky-stepper-cert-btn {
    font-size: 0.68rem;
    padding: 0.3rem 0.6rem;
  }
}

.audit-process-pagination-pill-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
  color: #6c757d;
  font-size: 0.8125rem;
}

.audit-process-pagination-pill {
  display: flex;
  align-items: center;
  gap: 4px;
  background: rgba(0, 0, 0, 0.03);
  border-radius: 24px;
  padding: 4px;
}

.audit-process-pagination-pill__btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 50%;
  padding: 0;
  background: transparent;
  color: #1a767e;
  box-shadow: none;
  cursor: pointer;
  transition: background 0.15s ease, box-shadow 0.15s ease;
}

.audit-process-pagination-pill__btn:not(:disabled):hover {
  background: #fff;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
}

.audit-process-pagination-pill__btn:disabled {
  color: #c1c7d0;
  cursor: default;
}

.audit-process-pagination-pill__label {
  padding: 0 0.5rem;
  font-size: 0.78rem;
  font-weight: 600;
  color: #1a767e;
}

/* "N/A — single standard" marker on checklist item #8 (Reduction of Type). Sits inside
   .audit-process-checklist-label, which is a flex child that already wraps, so the badge
   drops under the label text on narrow screens instead of squeezing the OK/Need Revision
   controls off the row. */
.audit-process-checklist-na-badge {
  display: inline-block;
  padding: 0.15rem 0.5rem;
  border-radius: 999px;
  font-size: 0.75rem;
  font-weight: 600;
  line-height: 1.4;
  white-space: nowrap;
  color: var(--tblr-secondary, #667382);
  background: rgba(102, 115, 130, 0.12);
  border: 1px solid rgba(102, 115, 130, 0.25);
}

.audit-process-multisite-coverage {
  padding: 1rem 1.1rem;
  border: 1px solid #dce4e8;
  border-left: 3px solid #1a767e;
  border-radius: 0.6rem;
  background: #f8fafb;
  color: #253746;
}

.audit-process-multisite-coverage__header {
  display: flex;
  align-items: center;
  gap: 0.65rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #e4eaed;
}

.audit-process-multisite-coverage__header strong,
.audit-process-multisite-coverage__header span {
  display: block;
}

.audit-process-multisite-coverage__header strong {
  font-size: 0.85rem;
  line-height: 1.25;
}

.audit-process-multisite-coverage__header div > span {
  margin-top: 0.15rem;
  color: #71808c;
  font-size: 0.72rem;
}

.audit-process-multisite-coverage__icon {
  display: grid !important;
  width: 2rem;
  height: 2rem;
  place-items: center;
  flex: 0 0 2rem;
  border-radius: 0.45rem;
  color: #1a767e;
  background: #e2f1f1;
}

.audit-process-multisite-coverage__list {
  display: grid;
  gap: 0.5rem;
  margin: 0;
  padding: 0.8rem 0 0;
  list-style: none;
}

.audit-process-multisite-coverage__item {
  display: flex;
  align-items: flex-start;
  gap: 0.65rem;
  min-width: 0;
  padding: 0.55rem 0.65rem;
  border: 1px solid #e5ebee;
  border-radius: 0.45rem;
  background: #fff;
}

.audit-process-multisite-coverage__number {
  display: grid;
  width: 1.35rem;
  height: 1.35rem;
  place-items: center;
  flex: 0 0 1.35rem;
  border-radius: 50%;
  color: #1a767e;
  background: #e2f1f1;
  font-size: 0.68rem;
  font-weight: 700;
}

.audit-process-multisite-coverage__details {
  display: grid;
  gap: 0.15rem;
  min-width: 0;
  font-size: 0.78rem;
}

.audit-process-multisite-coverage__details span {
  color: #71808c;
  overflow-wrap: anywhere;
  line-height: 1.35;
}

.audit-process-multisite-coverage__hint {
  margin-top: 0.75rem;
  color: #71808c;
  font-size: 0.72rem;
  line-height: 1.4;
}

.audit-process-multisite-coverage__empty {
  display: block;
  padding-top: 0.8rem;
  color: #b54747;
  font-size: 0.78rem;
}

/* Per-standard readiness dot on the grouped FTRD-02 certificate tabs. Colour is
   paired with a title attribute and visually-hidden text, so readiness is never
   communicated by hue alone. */
.audit-process-certificate-standard-tabs .nav-tabs .nav-link {
  display: inline-flex;
  align-items: center;
  gap: 0.45rem;
}

.audit-process-certificate-tab-dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.audit-process-certificate-tab-dot--ready {
  background: #1a767e;
}

.audit-process-certificate-tab-dot--incomplete {
  background: #ffffff;
  border: 2px solid #c0392b;
}

/* ── Inline document form: read-only context strip ──────────────────────────
   Replaces the old col-lg-4 sidebar (Client Info / Audit Scope & Criteria /
   Reference Documents). A minmax-floored grid, not a flex row of columns, per
   this repo's tile-layout rule: a plain flex row has no width floor and will
   letter-wrap "EAC-33L - Technology and Infrastructure" once the container gets
   narrow. Here the fields wrap to fewer per row instead of ever shrinking. */
.audit-process-form-context {
  border: 1px solid #e6edf3;
  border-radius: var(--audit-r-card);
  background: linear-gradient(180deg, #fbfdfd 0%, #ffffff 100%);
}

.audit-process-form-context__grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));
  gap: 16px 24px;
}

/* Scope is prose, not a short value -- it gets the full width of the strip. */
.audit-process-form-context__wide {
  grid-column: 1 / -1;
}

.audit-process-form-context__label {
  margin-bottom: 3px;
  color: #6c757d;
  font-size: 0.65rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.audit-process-form-context__docs {
  margin-top: 16px;
  padding-top: 14px;
  border-top: 1px solid #eef2f5;
}

.audit-process-form-context__doc {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  max-width: 320px;
  padding: 0.3rem 0.6rem;
  border: 1px solid #e3eaef;
  border-radius: var(--audit-r-input);
  background: #f8fafb;
  font-size: 0.8rem;
}

@media (max-width: 575.98px) {
  .audit-process-form-context__doc {
    max-width: 100%;
  }
}

/* ── Inline document form: back button + breadcrumb ─────────────────────────
   Back is the primary way out and reads as a control; the breadcrumb beside it
   is orientation. They share a row on desktop and stack on narrow screens so
   Back never gets squeezed against a long crumb trail. */
.audit-process-form-topbar {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 12px 16px;
}

.audit-process-form-back {
  display: inline-flex;
  align-items: center;
  border-radius: var(--audit-r-button);
  white-space: nowrap;
}

.audit-process-form-breadcrumb {
  --bs-breadcrumb-divider: '›';
  font-size: 0.8rem;
  margin: 0;
}

.audit-process-form-breadcrumb .breadcrumb-item,
.audit-process-form-breadcrumb .breadcrumb-item span {
  color: #6c757d;
}

.audit-process-form-breadcrumb .btn-link {
  color: #1a767e;
  font-size: 0.8rem;
  text-decoration: none;
  border: 0;
}

.audit-process-form-breadcrumb .btn-link:hover,
.audit-process-form-breadcrumb .btn-link:focus-visible {
  color: #0d5962;
  text-decoration: underline;
}

.audit-process-form-breadcrumb .breadcrumb-item.active {
  color: #16323f;
  font-weight: 600;
}

@media (max-width: 575.98px) {
  .audit-process-form-topbar {
    align-items: flex-start;
    flex-direction: column;
  }

  .audit-process-form-back {
    width: 100%;
    justify-content: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/AuditProcess/AuditProcess.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,gBAAgB;EAChB,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,UAAU;EACV,SAAS;EACT,iBAAiB;EACjB,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;AACvB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;;AAGA,mDAAmD;AACnD;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,0EAA0E;EAC1E,gBAAgB;EAChB,gBAAgB;EAChB,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,oGAAoG;EACpG,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,6DAA6D;EAC7D,wBAAwB;EACxB,cAAc;EACd,gFAAgF;AAClF;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;EACrB,0EAA0E;EAC1E,cAAc;EACd,mFAAmF;AACrF;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,UAAU;EACV,YAAY;EACZ,wBAAwB;EACxB;;;;;GAKC;EACD,0DAA0D;EAC1D,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,6DAA6D;EAC7D,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,WAAW;EACX,4DAA4D;AAC9D;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;EACnB,qCAAqC;EACrC,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;;;gEAGgE;AAChE;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,sBAAsB;EACtB,mBAAmB;EACnB,6DAA6D;EAC7D,yBAAyB;EACzB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;;;;qCAIqC;AACrC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,cAAc;AAChB;;AAEA;;sEAEsE;AACtE;;;;;;;EAOE,+BAA+B;AACjC;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE,mDAAmD;EACnD,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,qDAAqD;EACrD,0DAA0D;EAC1D,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,uCAAuC;AACvC;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA,wDAAwD;AACxD;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mDAAmD;EACnD,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,UAAU;EACV,YAAY;EACZ,wBAAwB;EACxB;;;;;GAKC;EACD,wDAAwD;EACxD,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;EACtB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,6DAA6D;EAC7D,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,+BAA+B;AACjC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,+EAA+E;EAC/E,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;;8FAE8F;AAC9F;EACE,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;sEACsE;AACtE;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,uBAAuB;EACvB,0BAA0B;EAC1B,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mDAAmD;EACnD,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,0BAA0B;EAC1B,eAAe;EACf,0BAA0B;EAC1B,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE;IACE,cAAc;IACd,gBAAgB;EAClB;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,gBAAgB;EAChB,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,qCAAqC;EACrC,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,8BAA8B;EAC9B,0BAA0B;EAC1B,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,6DAA6D;EAC7D,kDAAkD;AACpD;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,sCAAsC;EACtC,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;EACtC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,0BAA0B;EAC1B,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,0BAA0B;EAC1B,mBAAmB;EACnB,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,cAAc;EACd,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE;IACE,uBAAuB;IACvB,sBAAsB;IACtB,WAAW;EACb;AACF;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,4DAA4D;AAC9D;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,6DAA6D;AAC/D;;AAEA;EACE,sBAAsB;EACtB,mDAAmD;EACnD,kBAAkB;EAClB,qDAAqD;EACrD,gBAAgB;EAChB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,qBAAqB;EACrB,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;EACtC,eAAe;EACf,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,0BAA0B;EAC1B,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mCAAmC;EACnC,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mDAAmD;EACnD,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,YAAY;EACZ,uBAAuB;EACvB,yCAAyC;EACzC,8BAA8B;EAC9B,mBAAmB;EACnB,oBAAoB;EACpB,qFAAqF;AACvF;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,sBAAsB;AACxB;;AAEA;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,qFAAqF;AACvF;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;gGACgG;AAChG;EACE,qCAAqC;EACrC,0BAA0B;EAC1B,uFAAuF;AACzF;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,sCAAsC;EACtC,+BAA+B;EAC/B,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,0CAA0C;EAC1C,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,0DAA0D;AAC5D;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;;wEAEwE;AACxE;EACE,cAAc;EACd,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,kCAAkC;EAClC,qBAAqB;AACvB;;AAEA;EACE,2CAA2C;EAC3C,+CAA+C;EAC/C,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mDAAmD;EACnD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,0DAA0D;AAC5D;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,SAAO;AACT;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,yEAAyE;AAC3E;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,wBAAwB;EACxB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,6DAA6D;AAC/D;;AAEA;;;8DAG8D;AAC9D;EACE,yCAAyC;EACzC,kCAAkC;EAClC,8CAA8C;EAC9C,6DAA6D;AAC/D;;AAEA;;6DAE6D;AAC7D;;;EAGE,oCAAoC;AACtC;;AAEA;;wEAEwE;AACxE;EACE,cAAc;EACd,uBAAuB;EACvB,yBAAyB;EACzB,4DAA4D;EAC5D,gBAAgB;EAChB,UAAU;AACZ;;AAEA;;wEAEwE;AACxE;;EAEE,cAAc;EACd,oCAAoC;EACpC,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,6FAA6F;AAC/F;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,cAAc;EACd,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,uDAAuD;EACvD,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,kFAAkF;AACpF;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,mCAAmC;EACnC,mCAAmC;EACnC,8CAA8C;EAC9C,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;EACnC,mCAAmC;EACnC,8CAA8C;AAChD;;AAEA;EACE,WAAW;EACX,wCAAwC;AAC1C;;AAEA;EACE,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,cAAc;EACd,oCAAoC;AACtC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,uBAAuB;EACvB,kBAAkB;EAClB,mDAAmD;EACnD,uBAAuB;EACvB,qCAAqC;EACrC,4EAA4E;AAC9E;;AAEA;;EAEE,aAAa;EACb,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,kCAAkC;EAClC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA,6BAA6B;AAC7B;EACE,mCAAmC;AACrC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,6BAA6B;AAC7B;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,6BAA6B;AAC/B;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,eAAe;EACf,UAAU;EACV,oCAAoC;AACtC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,mDAAmD;AACnD;EACE,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,6CAA6C;AAC/C;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;EACtC,iBAAiB;AACnB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,qDAAqD;AACvD;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,sBAAsB;EACtB,6BAA6B;EAC7B,qBAAqB;EACrB,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,kFAAkF;AACpF;;AAEA;;EAEE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA,6CAA6C,mBAAmB,EAAE,cAAc,EAAE;AAClF,+CAA+C,mBAAmB,EAAE,cAAc,EAAE;;AAEpF;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,6BAA6B;EAC7B,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA,oCAAoC,cAAc,EAAE,kBAAkB,EAAE,yBAAyB,EAAE,sBAAsB,EAAE;AAC3H,sCAAsC,cAAc,EAAE,kBAAkB,EAAE;AAC1E,qCAAqC,cAAc,EAAE,iBAAiB,EAAE;;AAExE;EACE,aAAa;EACb,8BAA8B;EAC9B,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mCAAmC,0BAA0B,EAAE;EAC/D,wCAAwC,mBAAmB,EAAE;EAC7D,6BAA6B,gDAAgD,EAAE;AACjF;;AAEA;EACE,6BAA6B,0BAA0B,EAAE;AAC3D;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,6DAA6D;EAC7D,yBAAyB;EACzB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,cAAc;EACd,qCAAqC;EACrC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,2EAA2E;AAC7E;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,wFAAwF;EACxF,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,6DAA6D;EAC7D,+CAA+C;AACjD;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,6DAA6D;EAC7D,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;EACxB,oBAAoB;EACpB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,2DAA2D;EAC3D,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,wCAAwC;EACxC,WAAW;EACX,gCAAgC;EAChC,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gCAAgC;EAChC,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,oBAAoB;EACpB,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,wFAAwF;EACxF,0BAA0B;EAC1B,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,6DAA6D;EAC7D,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE;;IAEE,0CAA0C;IAC1C,UAAU;EACZ;EACA;IACE,UAAU;EACZ;EACA;IACE,aAAa;EACf;EACA;IACE,yCAAyC;IACzC,UAAU;EACZ;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;;EAEA;IACE,0BAA0B;IAC1B,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;EACpB;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,iBAAiB;IACjB,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;IACtB,wBAAwB;EAC1B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;IACX,eAAe;IACf,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA,oEAAoE;AACpE;EACE,6DAA6D;EAC7D,oCAAoC;EACpC,yCAAyC;EACzC,mBAAmB;EACnB,qBAAqB;EACrB,0DAA0D;AAC5D;;AAEA;EACE,8CAA8C;EAC9C,gCAAgC;EAChC,qCAAqC;AACvC;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,oEAAoE;AACpE;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,2BAA2B;EAC3B,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,wFAAwF;EACxF,0BAA0B;EAC1B,gCAAgC;EAChC,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;EACjB,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,mBAAmB;EACnB,8CAA8C;AAChD;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,cAAc;EACd,8CAA8C;AAChD;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,oEAAoE;AACpE;EACE,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,gCAAgC;EAChC,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA,mEAAmE;AACnE;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,WAAW;EACX,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,6DAA6D;AAC/D;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iFAAiF;AACnF;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,QAAQ;EACR,gCAAgC;EAChC,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,6CAA6C;EAC7C,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,sBAAsB;EACtB,gCAAgC;EAChC,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,UAAU;EACV,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,0DAA0D;EAC1D,0BAA0B;EAC1B,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,cAAc;EACd,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,oBAAoB;EACpB,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,6DAA6D;EAC7D,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;8EAE8E;AAC9E;EACE,kBAAkB;EAClB,yBAAyB;EACzB,yBAAyB;EACzB,mBAAmB;EACnB,6DAA6D;EAC7D,+CAA+C;EAC/C,iFAAiF;AACnF;;AAEA;EACE,qBAAqB;EACrB,6DAA6D;EAC7D,gFAAgF;AAClF;;AAEA;EACE,qBAAqB;EACrB,kFAAkF;AACpF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,sBAAsB;EACtB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;;EAEE,qBAAqB;EACrB,iDAAiD;AACnD;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,gCAAgC,eAAe,EAAE;EACjD,wCAAwC,kBAAkB,EAAE;AAC9D;;AAEA;;gFAEgF;AAChF;EAGE,gBAAgB;EAChB,yDAAiP;EACjP,4BAA4B;EAC5B,yCAAyC;EACzC,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA,yDAAyD;AACzD;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,0BAA0B;EAC1B,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;;;;oCAMoC;AACpC;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA;;;mFAGmF;AACnF;EACE,gBAAgB;EAChB,MAAM;EACN,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,6HAA6H;EAC7H,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,0EAA0E;EAC1E,6CAA6C;EAC7C,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,iDAAiD;EACjD,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qBAAqB;EACrB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,SAAO;EACP,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,qCAAqC;EACrC,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,YAAY;EACZ,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;EACrB,eAAe;EACf,uCAAuC;AACzC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;IAClB,sBAAsB;EACxB;AACF;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,+BAA+B;EAC/B,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,uBAAuB;EACvB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,gBAAgB;EAChB,yCAAyC;AAC3C;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;0BAG0B;AAC1B;EACE,qBAAqB;EACrB,uBAAuB;EACvB,oBAAoB;EACpB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,qCAAqC;EACrC,qCAAqC;EACrC,2CAA2C;AAC7C;;AAEA;EACE,oBAAoB;EACpB,yBAAyB;EACzB,8BAA8B;EAC9B,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;EACvB,gCAAgC;AAClC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,wBAAwB;EACxB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;EACd,sBAAsB;EACtB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,SAAS;EACT,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,wBAAwB;EACxB,yBAAyB;EACzB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;;+BAE+B;AAC/B;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;;;;;6EAK6E;AAC7E;EACE,yBAAyB;EACzB,kCAAkC;EAClC,6DAA6D;AAC/D;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,cAAc;AAChB;;AAEA,8EAA8E;AAC9E;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,mCAAmC;EACnC,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE;IACE,eAAe;EACjB;AACF;;AAEA;;;yDAGyD;AACzD;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,iBAAiB;EACjB,SAAS;AACX;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,qBAAqB;EACrB,SAAS;AACX;;AAEA;;EAEE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF","sourcesContent":["/* Audit Process page */\n.audit-process-page {\n  min-height: 100%;\n  padding-bottom: 2rem;\n  background: none;\n}\n\n/* Dark header */\n.audit-process-header {\n  color: #000000;\n  padding: 1rem 0;\n  flex-shrink: 0;\n}\n\n.audit-process-header-inner {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 1rem;\n}\n\n.audit-process-breadcrumb .breadcrumb {\n  background: transparent;\n  padding: 0;\n  margin: 0;\n  font-size: 0.9rem;\n  color: var(--tblr-secondary, #6c757d);\n}\n\n.audit-process-breadcrumb .breadcrumb-item a {\n  color: var(--tblr-secondary, #6c757d);\n  text-decoration: none;\n}\n\n.audit-process-breadcrumb .breadcrumb-item a:hover {\n  color: var(--tblr-body-color, #1e293b);\n}\n\n.audit-process-breadcrumb .breadcrumb-item.active {\n  color: var(--tblr-secondary, #6c757d);\n}\n\n.audit-process-breadcrumb .breadcrumb-item + .breadcrumb-item::before {\n  color: var(--tblr-secondary, #6c757d);\n}\n\n\n/* BE-driven Initial Certification stage overview */\n.audit-initial-stage-stepper {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  margin-bottom: 1rem;\n  padding: 0.8rem 0.9rem;\n  border: 1px solid #d9e7e8;\n  border-radius: 12px;\n  background: #f8fbfc;\n  overflow-x: auto;\n}\n\n.audit-initial-stage-step {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  min-width: max-content;\n  color: #718096;\n  font-size: 0.8rem;\n  font-weight: 700;\n}\n\n.audit-initial-stage-step__icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.65rem;\n  height: 1.65rem;\n  border-radius: 50%;\n  background: #e2e8f0;\n  color: #64748b;\n  font-size: 0.72rem;\n}\n\n.audit-initial-stage-step.is-current {\n  color: #0f766e;\n}\n\n.audit-initial-stage-step.is-current .audit-initial-stage-step__icon {\n  background: #0f9f95;\n  color: #fff;\n  box-shadow: 0 0 0 4px rgba(15, 159, 149, 0.12);\n}\n\n.audit-initial-stage-step.is-completed {\n  color: #3f7d15;\n}\n\n.audit-initial-stage-step.is-completed .audit-initial-stage-step__icon {\n  background: #65a30d;\n  color: #fff;\n}\n\n.audit-initial-stage-step.is-locked {\n  color: #94a3b8;\n}\n\n.audit-initial-stage-step.needs-revision .audit-initial-stage-step__icon {\n  background: #f59e0b;\n  color: #fff;\n}\n\n.audit-initial-stage-step__line {\n  width: 34px;\n  min-width: 34px;\n  height: 2px;\n  background: #d4dee4;\n}\n\n/* Inline stepper inside each stage card */\n.audit-process-inline-stepper {\n  position: relative;\n  margin-bottom: 1rem;\n  border: 1px solid #cfe7e5;\n  border-radius: 14px;\n  background: linear-gradient(135deg, #f8fffe 0%, #f3fbff 48%, #f7fbff 100%);\n  padding: 0.95rem;\n  overflow: hidden;\n  box-shadow: 0 12px 28px rgba(15, 118, 110, 0.08);\n}\n\n.audit-process-inline-stepper::before {\n  content: '';\n  position: absolute;\n  width: 260px;\n  height: 260px;\n  border-radius: 50%;\n  right: -110px;\n  top: -130px;\n  background: radial-gradient(circle at center, rgba(45, 212, 191, 0.2) 0%, rgba(45, 212, 191, 0) 70%);\n  pointer-events: none;\n}\n\n.audit-process-inline-stepper-major {\n  display: flex;\n  align-items: stretch;\n  gap: 0.55rem;\n  overflow-x: auto;\n  padding-bottom: 0.15rem;\n  scrollbar-width: thin;\n}\n\n.audit-process-inline-major-item {\n  min-width: 170px;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  border: 1px solid #d6dde6;\n  border-radius: 10px;\n  background: linear-gradient(180deg, #f8fbff 0%, #f2f6fb 100%);\n  padding: 0.55rem 0.65rem;\n  color: #5f7089;\n  transition: transform 0.16s ease, box-shadow 0.16s ease, border-color 0.16s ease;\n}\n\n.audit-process-inline-major-item:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 6px 14px rgba(148, 163, 184, 0.2);\n}\n\n.audit-process-inline-major-item.is-current {\n  position: relative;\n  overflow: hidden;\n  border-color: #14b8a6;\n  background: linear-gradient(135deg, #dcfffb 0%, #e6fffb 60%, #effffb 100%);\n  color: #0f766e;\n  box-shadow: 0 0 0 1px rgba(20, 184, 166, 0.2), 0 10px 18px rgba(13, 148, 136, 0.16);\n}\n\n.audit-process-inline-major-item.is-current::after {\n  content: '';\n  position: absolute;\n  top: -120%;\n  left: -46%;\n  width: 44%;\n  height: 340%;\n  transform: rotate(25deg);\n  background: linear-gradient(\n    90deg,\n    rgba(255, 255, 255, 0) 0%,\n    rgba(255, 255, 255, 0.34) 45%,\n    rgba(255, 255, 255, 0) 100%\n  );\n  animation: audit-process-shimmer 4.8s ease-in-out infinite;\n  pointer-events: none;\n}\n\n.audit-process-inline-major-item.is-completed {\n  border-color: #84cc16;\n  background: linear-gradient(180deg, #f8ffe8 0%, #ecfccb 100%);\n  color: #4d7c0f;\n}\n\n.audit-process-inline-major-num {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.75rem;\n  height: 1.75rem;\n  border-radius: 0.45rem;\n  background: #dbe1e8;\n  color: #4b5563;\n  font-size: 0.88rem;\n  font-weight: 700;\n  flex-shrink: 0;\n}\n\n.audit-process-inline-major-item.is-current .audit-process-inline-major-num {\n  background: #20a29c;\n  color: #ffffff;\n}\n\n.audit-process-inline-major-item.is-completed .audit-process-inline-major-num {\n  background: #8ac926;\n  color: #ffffff;\n}\n\n.audit-process-inline-major-text {\n  font-size: 0.84rem;\n  line-height: 1.2;\n  font-weight: 600;\n}\n\n.audit-process-inline-major-divider {\n  width: 18px;\n  min-width: 18px;\n  align-self: center;\n  height: 2px;\n  background: linear-gradient(90deg, #d9dde3 0%, #c7d0db 100%);\n}\n\n.audit-process-inline-stepper-sub {\n  margin-top: 0.7rem;\n  display: flex;\n  align-items: center;\n  gap: 0.55rem;\n  overflow-x: auto;\n  padding: 0.5rem 0.4rem 0.25rem;\n  border-radius: 10px;\n  background: rgba(255, 255, 255, 0.72);\n  border: 1px dashed #dbe4ee;\n  scrollbar-width: thin;\n}\n\n.audit-process-inline-sub-item {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  color: #64748b;\n  font-size: 0.86rem;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.audit-process-inline-sub-item.is-current {\n  color: #0f766e;\n}\n\n.audit-process-inline-sub-item.is-completed {\n  color: #4d7c0f;\n}\n\n.audit-process-inline-sub-dot {\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  border: 2px solid #cbd5e1;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #ffffff;\n  background: #f8fafc;\n  flex-shrink: 0;\n}\n\n.audit-process-inline-sub-item.is-current .audit-process-inline-sub-dot {\n  border-color: #20a29c;\n  background: #20a29c;\n}\n\n.audit-process-inline-sub-item.is-completed .audit-process-inline-sub-dot {\n  border-color: #8ac926;\n  background: #8ac926;\n}\n\n.audit-process-inline-sub-divider {\n  width: 46px;\n  min-width: 46px;\n  height: 2px;\n  background: #d9dde3;\n}\n\n/* Compact one-line \"Audit Completed\" summary — replaces the full major-step\n   chip breakdown + celebration banner once every stage is done, since at\n   that point the group-level Stage overview above already shows the same\n   completion. Much shorter than the two elements it replaces. */\n.audit-process-completed-summary {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.6rem;\n  padding: 0.6rem 0.9rem;\n  border-radius: 10px;\n  background: linear-gradient(135deg, #ecfdf5 0%, #eafffb 100%);\n  border: 1px solid #99e6da;\n  color: #0f766e;\n  font-size: 0.85rem;\n}\n\n.audit-process-completed-summary-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 1.35rem;\n  height: 1.35rem;\n  border-radius: 50%;\n  background: #14b8a6;\n  color: #fff;\n  font-weight: 700;\n  font-size: 0.72rem;\n  flex-shrink: 0;\n}\n\n.audit-process-completed-summary-text {\n  flex: 1;\n  min-width: 200px;\n  font-weight: 600;\n}\n\n.audit-process-completed-summary-link {\n  flex-shrink: 0;\n  font-weight: 700;\n  font-size: 0.8rem;\n  color: #0d3d42;\n  background: #fff;\n  padding: 0.3rem 0.75rem;\n  border-radius: 6px;\n  text-decoration: none;\n  white-space: nowrap;\n}\n\n.audit-process-completed-summary-link:hover {\n  color: #0d3d42;\n  background: #dcfffb;\n}\n\n.audit-process-completed-summary-link:focus-visible {\n  outline: 2px solid #0d9488;\n  outline-offset: 2px;\n}\n\n/* Documents/Forms doc row — was a single-line d-flex justify-content-between\n   that overflowed on mobile once the scope badge + 3 export buttons + upload\n   + form button all fought for the same row. Scope is now shown once in the\n   selector above, exports are gone, and the row wraps to a stacked layout\n   below 576px instead of clipping. */\n.audit-process-doc-row-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 0.6rem;\n  padding: 0.85rem 1rem;\n}\n\n.audit-process-doc-row-title {\n  min-width: 0;\n  flex: 1 1 220px;\n}\n\n.audit-process-doc-row-actions {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  flex-shrink: 0;\n}\n\n/* Native controls are covered by the fieldset, but custom selects and their\n   remove buttons render as non-native elements. Keep the form readable while\n   preventing every edit interaction in the explicit read-only view. */\n.audit-form-read-only button,\n.audit-form-read-only input,\n.audit-form-read-only select,\n.audit-form-read-only textarea,\n.audit-form-read-only [role='combobox'],\n.audit-form-read-only [contenteditable='true'],\n.audit-form-read-only [class*='multi-value__remove'] {\n  pointer-events: none !important;\n}\n\n@media (max-width: 575.98px) {\n  .audit-process-doc-row-top {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .audit-process-doc-row-actions {\n    justify-content: flex-start;\n  }\n}\n\n.audit-process-card {\n  border: 1px solid var(--tblr-border-color, #e6e7e9);\n  border-radius: 8px;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n}\n\n.audit-process-card-header {\n  background: var(--tblr-bg-surface-secondary, #f8f9fa);\n  border-bottom: 1px solid var(--tblr-border-color, #e6e7e9);\n  padding: 0.75rem 1rem;\n  font-weight: 600;\n}\n\n.audit-process-card-main .card-body {\n  padding: 1.25rem;\n}\n\n/* Teal buttons (match design accent) */\n.audit-process-page .btn-teal {\n  background: #0d9488;\n  color: #fff;\n  border: none;\n  padding: 0.5rem 1.25rem;\n  border-radius: 6px;\n}\n\n.audit-process-page .btn-teal:hover {\n  background: #0f766e;\n  color: #fff;\n}\n\n/* Title & project ID */\n.audit-process-title {\n  font-size: 1.35rem;\n  font-weight: 600;\n  color: var(--tblr-body-color, #1e293b);\n}\n\n.audit-process-project-id {\n  font-weight: 500;\n  color: var(--tblr-muted, #64748b);\n}\n\n/* Audit stages (collapsible) – card-style like design */\n.audit-process-stages {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  margin-top: 1rem;\n}\n\n.audit-process-stage-item {\n  background: #fff;\n  border: 1px solid var(--tblr-border-color, #e6e7e9);\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n  overflow: hidden;\n}\n\n.audit-process-stage-item.is-expanded {\n  position: relative;\n  border-color: #5eead4;\n  box-shadow: 0 10px 24px rgba(13, 148, 136, 0.16);\n}\n\n.audit-process-stage-item.is-expanded::after {\n  content: '';\n  position: absolute;\n  top: -50%;\n  left: -28%;\n  width: 32%;\n  height: 220%;\n  transform: rotate(20deg);\n  background: linear-gradient(\n    90deg,\n    rgba(255, 255, 255, 0) 0%,\n    rgba(255, 255, 255, 0.28) 48%,\n    rgba(255, 255, 255, 0) 100%\n  );\n  animation: audit-process-shimmer 6s ease-in-out infinite;\n  pointer-events: none;\n}\n\n.audit-process-stage-item-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.875rem 1rem;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.audit-process-stage-item-header:hover {\n  background: var(--tblr-bg-surface-secondary, #f8f9fa);\n}\n\n.audit-process-stage-item.is-expanded .audit-process-stage-item-header {\n  background: linear-gradient(135deg, #ecfeff 0%, #f0fdfa 100%);\n  border-bottom: 1px solid #99f6e4;\n}\n\n.audit-process-stage-item.is-expanded .audit-process-stage-name {\n  color: #0f766e;\n}\n\n.audit-process-stage-item.is-expanded .audit-process-stage-chevron {\n  color: #0f766e;\n}\n\n.audit-process-stage-item-header-left {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.audit-process-stage-name {\n  font-weight: 600;\n  font-size: 1rem;\n  color: var(--tblr-body-color, #1e293b);\n}\n\n.audit-process-stage-status.badge {\n  font-size: 0.8rem;\n  font-weight: 500;\n  padding: 0.25em 0.6em;\n  border-radius: 9999px;\n}\n\n.audit-process-stage-status.badge-audit-completed {\n  background: rgba(25, 135, 84, 0.15);\n  color: #198754;\n}\n\n.audit-process-stage-status.badge-checklist {\n  background: #fef3c7;\n  color: #b45309;\n}\n\n.audit-process-stage-status.badge-next-audit {\n  background: #e2e8f0;\n  color: #475569;\n}\n\n.audit-process-stage-service-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.22rem 0.6rem;\n  border-radius: 9999px;\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: #1d4ed8;\n  background: #dbeafe;\n  border: 1px solid #93c5fd;\n}\n\n.audit-process-stage-chevron {\n  flex-shrink: 0;\n  color: var(--tblr-muted, #64748b);\n  transition: transform 0.2s ease;\n}\n\n.audit-process-stage-chevron.open {\n  transform: rotate(180deg);\n}\n\n.audit-process-stage-item-body {\n  padding: 0 1rem 1rem;\n  border-top: 1px solid var(--tblr-border-color-translucent, rgba(0, 0, 0, 0.06));\n  padding-top: 1rem;\n  margin-left: 0;\n  margin-right: 0;\n}\n\n.audit-process-stage-fields {\n  display: grid;\n  grid-template-columns: 1fr 1fr 2fr;\n  gap: 1.25rem;\n  margin-bottom: 1rem;\n}\n\n@media (max-width: 768px) {\n  .audit-process-stage-fields {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Sustainability/ISCC scope stages show more fields (Registration Number, Input/Output\n   Material, GHG Calculation) instead of EA Code -- use an even grid so extra fields\n   don't inherit the wide 2fr column meant for Scope, with Scope always spanning full width. */\n.audit-process-stage-fields.is-sustainability {\n  grid-template-columns: repeat(2, 1fr);\n}\n\n.audit-process-stage-fields.is-sustainability .audit-process-stage-field-scope {\n  grid-column: 1 / -1;\n}\n\n@media (max-width: 768px) {\n  .audit-process-stage-fields.is-sustainability {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Collapsed Mandays/EA Code/Scope summary for a fully completed cycle — one\n   adaptive line instead of the full 3-column grid, click to expand. */\n.audit-process-stage-fields-summary {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n  width: 100%;\n  margin-bottom: 1rem;\n  padding: 0.6rem 0.85rem;\n  border: 1px dashed #cdd9e6;\n  border-radius: 10px;\n  background: #f8fafc;\n  color: #334155;\n  font-size: 0.82rem;\n  text-align: left;\n  cursor: pointer;\n  transition-property: background-color, border-color;\n  transition-duration: 150ms;\n  transition-timing-function: ease-out;\n}\n\n.audit-process-stage-fields-summary:hover {\n  background: #eef2f7;\n  border-color: #b7c6d8;\n}\n\n.audit-process-stage-fields-summary:focus-visible {\n  outline: 2px solid #14b8a6;\n  outline-offset: 2px;\n}\n\n.audit-process-stage-fields-summary strong {\n  color: #0f766e;\n  font-weight: 700;\n  margin-right: 0.3rem;\n}\n\n.audit-process-stage-fields-summary-sep {\n  color: #b0bec9;\n}\n\n.audit-process-stage-fields-summary-scope {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  flex: 1 1 160px;\n}\n\n.audit-process-stage-fields-summary-cta {\n  flex-shrink: 0;\n  margin-left: auto;\n  font-weight: 700;\n  color: #14b8a6;\n  text-decoration: underline;\n}\n\n.audit-process-stage-fields-toggle {\n  display: inline-flex;\n  align-items: center;\n  margin: 0 0 1rem;\n  padding: 0.3rem 0;\n  min-height: 40px;\n  border: none;\n  background: none;\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: #0f766e;\n  text-decoration: underline;\n  cursor: pointer;\n  transition-property: color;\n  transition-duration: 150ms;\n  transition-timing-function: ease-out;\n}\n\n.audit-process-stage-fields-toggle:hover,\n.audit-process-stage-fields-toggle:focus-visible {\n  color: #14b8a6;\n}\n\n.audit-process-stage-fields-toggle:focus-visible {\n  outline: 2px solid #14b8a6;\n  outline-offset: 2px;\n  border-radius: 4px;\n}\n\n@media (max-width: 575.98px) {\n  .audit-process-stage-fields-summary-cta {\n    margin-left: 0;\n    flex-basis: 100%;\n  }\n}\n\n.audit-process-fscp03-toggle {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  min-height: 48px;\n  padding: 0.85rem 1rem;\n  border: none;\n  background: #f8fafc;\n  cursor: pointer;\n  text-align: left;\n  transition-property: background-color;\n  transition-duration: 150ms;\n  transition-timing-function: ease-out;\n}\n\n.audit-process-fscp03-toggle:hover {\n  background: #f1f5f9;\n}\n\n.audit-process-fscp03-toggle:focus-visible {\n  outline: 2px solid #14b8a6;\n  outline-offset: -2px;\n}\n\n.audit-process-fscp03-toggle-chevron {\n  color: #64748b;\n  flex-shrink: 0;\n  transition-property: transform;\n  transition-duration: 150ms;\n  transition-timing-function: ease-out;\n}\n\n.audit-process-fscp03-toggle-chevron.open {\n  transform: rotate(180deg);\n}\n\n.audit-process-stage-field {\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  padding: 0.8rem 0.85rem;\n  border: 1px solid #dbe5f0;\n  border-radius: 12px;\n  background: linear-gradient(180deg, #ffffff 0%, #f8fbff 100%);\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.7);\n}\n\n.audit-process-stage-field-label {\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: var(--tblr-body-color, #1e293b);\n  margin: 0;\n}\n\n.audit-process-stage-field-value {\n  font-size: 1.03rem;\n  font-weight: 600;\n  color: var(--tblr-body-color, #1e293b);\n  min-height: 1.5rem;\n  font-variant-numeric: tabular-nums;\n}\n\n.audit-process-stage-mandays-link {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 0.75rem;\n  width: 100%;\n  padding: 0;\n  border: 0;\n  background: transparent;\n  text-align: left;\n  cursor: pointer;\n}\n\n.audit-process-stage-mandays-link-hint {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  color: #16837d;\n  font-size: 0.72rem;\n  font-weight: 700;\n  letter-spacing: 0.015em;\n  white-space: nowrap;\n}\n\n.audit-process-stage-mandays-link:hover .audit-process-stage-field-value,\n.audit-process-stage-mandays-link:focus-visible .audit-process-stage-field-value {\n  color: #0e7771;\n  text-decoration: underline;\n  text-decoration-thickness: 1px;\n  text-underline-offset: 3px;\n}\n\n.audit-process-stage-mandays-link:focus-visible {\n  outline: 2px solid #2a9d96;\n  outline-offset: 4px;\n  border-radius: 5px;\n}\n\n.audit-process-cid2-modal-content {\n  overflow: hidden;\n}\n\n.audit-process-cid2-modal-content .modal-header {\n  border-top: 3px solid #24a19c;\n  align-items: flex-start;\n}\n\n.audit-process-cid2-modal-kicker {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  color: #16837d;\n  font-size: 0.71rem;\n  font-weight: 800;\n  letter-spacing: 0.08em;\n  text-transform: uppercase;\n}\n\n.audit-process-cid2-empty-state {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 1.1rem;\n  border: 1px dashed #b9c8d7;\n  border-radius: 12px;\n  background: linear-gradient(135deg, #f7fbfc 0%, #f8fafc 100%);\n}\n\n.audit-process-cid2-empty-icon {\n  display: grid;\n  flex: 0 0 auto;\n  width: 2.7rem;\n  height: 2.7rem;\n  place-items: center;\n  border-radius: 10px;\n  color: #64748b;\n  background: #e7eef4;\n}\n\n@media (max-width: 520px) {\n  .audit-process-stage-mandays-link {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 0.2rem;\n  }\n}\n\n.audit-process-stage-field-line {\n  height: 2px;\n  border-radius: 99px;\n  background: linear-gradient(90deg, #c7d2e2 0%, #e2e8f0 100%);\n}\n\n.audit-process-stage-field-scope .audit-process-stage-field-value {\n  font-weight: 400;\n  font-size: 0.9rem;\n  line-height: 1.45;\n  min-height: 4rem;\n}\n\n.audit-process-stage-field-scope {\n  border-color: #cfe2f6;\n  background: linear-gradient(180deg, #f8fbff 0%, #f3f8ff 100%);\n}\n\n.audit-process-stage-scope-value {\n  padding: 0.5rem 0.6rem;\n  border: 1px solid var(--tblr-border-color, #e6e7e9);\n  border-radius: 6px;\n  background: var(--tblr-bg-surface-secondary, #f8f9fa);\n  min-height: 4rem;\n  white-space: pre-wrap;\n  word-break: break-word;\n}\n\n.audit-process-stage-field-scope .audit-process-stage-field-line.scope-line {\n  margin-top: 0.25rem;\n}\n\n.audit-process-stage-edit-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.5rem 1rem;\n  font-size: 0.9rem;\n  font-weight: 500;\n  color: #fff;\n  background: #0d9488;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n\n.audit-process-stage-edit-btn:hover {\n  background: #0f766e;\n  color: #fff;\n}\n\n/* Documents nav */\n.audit-process-doc-nav {\n  display: flex;\n  flex-direction: column;\n}\n\n.audit-process-doc-nav-item {\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: 0.75rem 1rem;\n  border: none;\n  background: transparent;\n  text-align: left;\n  font-size: 0.95rem;\n  color: var(--tblr-body-color, #1e293b);\n  cursor: pointer;\n  transition: background 0.15s ease;\n  border-radius: 0;\n}\n\n.audit-process-doc-nav-item:hover {\n  background: var(--tblr-bg-surface-secondary, #f1f3f5);\n}\n\n.audit-process-doc-nav-item:focus-visible {\n  outline: 2px solid #0d9488;\n  outline-offset: -2px;\n  z-index: 1;\n}\n\n.audit-process-doc-nav-item {\n  border-left: 3px solid transparent;\n}\n\n.audit-process-doc-nav-item.active {\n  background: rgba(13, 148, 136, 0.1);\n  border-left-color: #0d9488;\n  color: #0d9488;\n  font-weight: 600;\n}\n\n.audit-process-doc-nav-check {\n  flex-shrink: 0;\n  color: #198754;\n}\n\n.audit-process-doc-nav-item.active .audit-process-doc-nav-check {\n  color: #0d9488;\n}\n\n.audit-process-doc-section {\n  border: 1px solid var(--tblr-border-color, #e6e7e9);\n  border-radius: 8px;\n  padding: 0.75rem;\n  background: #ffffff;\n}\n\n/* CID revision/follow-up panel (Sales Pack tab) */\n.audit-process-revision-card {\n  display: flex;\n  gap: 0.85rem;\n  align-items: flex-start;\n  border: 1px solid rgba(245, 159, 0, 0.35);\n  border-left: 4px solid #f59f00;\n  border-radius: 10px;\n  padding: 1rem 1.1rem;\n  background: linear-gradient(180deg, rgba(245, 159, 0, 0.06), rgba(245, 159, 0, 0.02));\n}\n\n.audit-process-revision-card__icon {\n  flex-shrink: 0;\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(245, 159, 0, 0.15);\n  color: #b76e00;\n}\n\n.audit-process-revision-card__body {\n  flex: 1;\n  min-width: 0;\n}\n\n.audit-process-revision-card__title {\n  font-weight: 600;\n  font-size: 0.92rem;\n  color: #7a4a00;\n  margin-bottom: 0.2rem;\n}\n\n.audit-process-revision-card__assignee {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  border-radius: 999px;\n  padding: 0.3rem 0.65rem;\n  background: #e6f0fd;\n  color: #1f5eab;\n  font-size: 0.78rem;\n  font-weight: 700;\n}\n\n.audit-process-revision-card__desc {\n  font-size: 0.82rem;\n  color: var(--tblr-secondary-color, #6b7280);\n  margin-bottom: 0.75rem;\n}\n\n.audit-process-revision-card--success {\n  border-color: rgba(45, 164, 78, 0.35);\n  border-left-color: #2ba44e;\n  background: linear-gradient(180deg, rgba(45, 164, 78, 0.08), rgba(45, 164, 78, 0.02));\n}\n\n.audit-process-revision-card--success .audit-process-revision-card__icon {\n  background: rgba(45, 164, 78, 0.15);\n  color: #2b8a3e;\n}\n\n.audit-process-revision-card--success .audit-process-revision-card__title {\n  color: #206c3c;\n}\n\n/* Neutral \"awaiting review\" state (e.g. follow-up submitted, pending AR re-review) —\n   teal to match the brand accent, distinct from the warning (orange) / success (green) tones. */\n.audit-process-revision-card--info {\n  border-color: rgba(31, 101, 108, 0.3);\n  border-left-color: #1f656c;\n  background: linear-gradient(180deg, rgba(31, 101, 108, 0.06), rgba(31, 101, 108, 0.02));\n}\n\n.audit-process-revision-card--info .audit-process-revision-card__icon {\n  background: rgba(31, 101, 108, 0.12);\n  color: #1f656c;\n}\n\n.audit-process-revision-card--info .audit-process-revision-card__title {\n  color: #164c52;\n}\n\n.audit-process-revision-card__meta-list {\n  list-style: none;\n  margin: 0 0 0.75rem;\n  padding: 0;\n  display: flex;\n  flex-direction: column;\n  gap: 0.3rem;\n}\n\n.audit-process-revision-card__meta-list li {\n  font-size: 0.82rem;\n  color: var(--tblr-body-color, #1e293b);\n  background: rgba(0, 0, 0, 0.03);\n  border-radius: 6px;\n  padding: 0.35rem 0.6rem;\n}\n\n.audit-process-revision-card__hint {\n  font-size: 0.78rem;\n  color: var(--tblr-secondary-color, #6b7280);\n  margin-top: 0.5rem;\n}\n\n.audit-process-revision-card__files {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-bottom: 0.85rem;\n}\n\n.audit-process-revision-card__file-chip {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.4rem 0.75rem;\n  border: 1px dashed rgba(245, 159, 0, 0.55);\n  border-radius: 999px;\n  background: #fff;\n  color: #b76e00;\n  font-size: 0.8rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s ease, border-color 0.15s ease;\n}\n\n.audit-process-revision-card__file-chip:hover {\n  background: rgba(245, 159, 0, 0.08);\n  border-color: #f59f00;\n}\n\n.audit-process-revision-card__file-chip.is-uploaded {\n  border-style: solid;\n  border-color: rgba(45, 164, 78, 0.5);\n  background: rgba(45, 164, 78, 0.08);\n  color: #2b8a3e;\n}\n\n.audit-process-revision-card__file-chip.is-uploaded:hover {\n  background: rgba(45, 164, 78, 0.14);\n  border-color: #2ba44e;\n}\n\n.audit-process-revision-card__footer {\n  display: flex;\n  justify-content: flex-end;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  padding-top: 0.6rem;\n  border-top: 1px dashed rgba(245, 159, 0, 0.3);\n}\n\n.audit-process-revision-card--success .audit-process-revision-card__footer {\n  border-top-color: rgba(45, 164, 78, 0.3);\n}\n\n.audit-process-revision-card--info .audit-process-revision-card__footer {\n  border-top-color: rgba(31, 101, 108, 0.25);\n}\n\n/* \"Need Revision\" sits next to the primary \"Mark Resolved\" action -- kept neutral by default so\n   it doesn't compete with the primary button, with a warning-tinted hover/focus so its intent\n   (sending back for another round) is still legible before the click. */\n.audit-process-revision-card__btn-ghost {\n  color: #92600a;\n  border-color: rgba(245, 159, 0, 0.4);\n  background: #fff;\n}\n\n.audit-process-revision-card__btn-ghost:hover:not(:disabled),\n.audit-process-revision-card__btn-ghost:focus-visible:not(:disabled) {\n  color: #7a4a00;\n  background: rgba(245, 159, 0, 0.1);\n  border-color: #f59f00;\n}\n\n.audit-process-revision-card__btn-ghost:disabled {\n  color: var(--tblr-secondary-color, #9aa4b2);\n  border-color: var(--tblr-border-color, #dfe3e8);\n  background: #fff;\n}\n\n.audit-process-doc-section-title {\n  font-weight: 600;\n  font-size: 0.95rem;\n  color: var(--tblr-body-color, #1e293b);\n  margin-bottom: 0.35rem;\n}\n\n.audit-process-doc-group {\n  margin-top: 0.5rem;\n}\n\n.audit-process-doc-group-title {\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  color: #64748b;\n  margin-bottom: 0.35rem;\n}\n\n.audit-process-doc-file-list {\n  border: 1px solid var(--tblr-border-color, #e6e7e9);\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.audit-process-doc-file-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  padding: 0.6rem 0.75rem;\n  background: #f8fafc;\n  border-bottom: 1px solid var(--tblr-border-color, #e6e7e9);\n}\n\n.audit-process-doc-file-row:last-child {\n  border-bottom: none;\n}\n\n.audit-process-doc-file-meta {\n  min-width: 0;\n  flex: 1;\n}\n\n.audit-process-doc-file-name {\n  display: block;\n  font-weight: 500;\n  color: #334155;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.audit-process-doc-file-actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n}\n\n.audit-process-doc-icon-btn {\n  width: 32px;\n  height: 32px;\n  border: none;\n  border-radius: 8px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #eef2ff;\n  color: #2563eb;\n  cursor: pointer;\n  transition: background 0.15s ease, color 0.15s ease, transform 0.15s ease;\n}\n\n.audit-process-doc-icon-btn:hover {\n  background: #dbeafe;\n  color: #1d4ed8;\n  transform: translateY(-1px);\n}\n\n.audit-process-doc-preview-frame {\n  width: 100%;\n  height: min(76vh, 820px);\n  border: 0;\n  background: #f8fafc;\n}\n\n.audit-process-preview-state {\n  min-height: 420px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 0.75rem;\n  padding: 2rem;\n}\n\n.audit-process-output-template-card {\n  border: 1px solid #dbeafe;\n  border-radius: 16px;\n  padding: 16px;\n  background: linear-gradient(180deg, #f8fbff 0%, #ffffff 100%);\n}\n\n/* The certificate preview sits directly under the FTRD-02 form, which is teal\n   (--audit-accent #1a767e). This card used to be blue (#dbeafe border, blue\n   shadow), so the column read as two unrelated surfaces stacked on top of each\n   other. Retuned onto the same teal ramp as the form shell. */\n.audit-process-inline-certificate-preview-card {\n  border: 1px solid rgba(26, 118, 126, 0.2);\n  border-radius: var(--audit-r-card);\n  box-shadow: 0 14px 34px rgba(15, 89, 98, 0.07);\n  background: linear-gradient(180deg, #f8fcfc 0%, #ffffff 100%);\n}\n\n/* This card lives outside .audit-form-shell, so it does not inherit the shell's\n   button radius -- restate it here so the Preview/Download/Issue row matches\n   the FTRD-02 form's own footer buttons directly above it. */\n.audit-process-inline-certificate-preview-card .btn,\n.audit-process-inline-certificate-preview-card .alert,\n.audit-process-inline-certificate-preview-card .badge {\n  border-radius: var(--audit-r-button);\n}\n\n/* Grouped (multi-standard) certificate issuance: one tab per standard.\n   Tabler's default --tblr-nav-link-color is white, which makes inactive tabs\n   invisible on the white card, so the colors are set explicitly here. */\n.audit-process-certificate-standard-tabs .nav-tabs .nav-link {\n  color: #475569;\n  background: transparent;\n  border-color: transparent;\n  border-radius: var(--audit-r-input) var(--audit-r-input) 0 0;\n  font-weight: 600;\n  opacity: 1;\n}\n\n/* Accent matches the form shell's --audit-accent (#1a767e), not the slightly\n   different teal these tabs used to carry (#0f766e) — the tabs, the form below\n   them and the preview card are one surface and must read as one hue. */\n.audit-process-certificate-standard-tabs .nav-tabs .nav-link:hover,\n.audit-process-certificate-standard-tabs .nav-tabs .nav-link:focus {\n  color: #1a767e;\n  background: rgba(26, 118, 126, 0.08);\n  border-color: transparent;\n}\n\n.audit-process-certificate-standard-tabs .nav-tabs .nav-link.active {\n  color: #1a767e;\n  background: #ffffff;\n  border-color: var(--tblr-border-color, #e6e7e9) var(--tblr-border-color, #e6e7e9) transparent;\n}\n\n.audit-process-inline-certificate-preview-stage {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  overflow: auto;\n  padding-bottom: 6px;\n}\n\n/* Audit Contact */\n.audit-process-contact-block {\n  border-top: 1px solid var(--tblr-border-color, #e6e7e9);\n  padding-top: 1rem;\n  margin-top: 1rem;\n}\n\n.audit-process-contact-block:first-child {\n  border-top: none;\n  padding-top: 0;\n  margin-top: 0;\n}\n\n.audit-process-contact-block-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-bottom: 0.75rem;\n}\n\n.audit-process-contact-block-title {\n  font-size: 1.05rem;\n  font-weight: 700;\n  color: #1f2937;\n}\n\n.audit-process-contact-sameas {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  color: #334155;\n  font-size: 0.95rem;\n  font-weight: 500;\n}\n\n.audit-process-contact-sameas input {\n  width: 18px;\n  height: 18px;\n  accent-color: #0d9488;\n}\n\n.audit-process-contact-grid {\n  display: grid;\n  grid-template-columns: 220px 16px 1fr;\n  row-gap: 0.65rem;\n  column-gap: 0.45rem;\n  align-items: center;\n}\n\n.audit-process-contact-label {\n  font-size: 0.95rem;\n  font-weight: 600;\n  color: #374151;\n}\n\n.audit-process-contact-colon {\n  font-weight: 700;\n  color: #64748b;\n  text-align: center;\n}\n\n.audit-process-contact-input-wrap {\n  display: flex;\n  flex-direction: column;\n}\n\n.audit-process-contact-input {\n  min-height: 2.4rem;\n}\n\n.audit-process-contact-input:disabled {\n  background: #f1f5f9;\n}\n\n.audit-process-contact-value {\n  min-height: 2.8rem;\n  padding: 0.55rem 0.8rem;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #f1f5f9;\n  color: #334155;\n  font-size: 0.95rem;\n  font-weight: 600;\n  display: flex;\n  align-items: center;\n}\n\n/* Checklist */\n.audit-process-checklist {\n  margin: 0 0 1rem 0;\n  padding: 0;\n}\n\n.audit-process-checklist-item {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.6rem 0;\n  border-bottom: 1px solid var(--tblr-border-color-translucent, rgba(0, 0, 0, 0.06));\n}\n\n.audit-process-checklist-item:last-of-type {\n  border-bottom: none;\n}\n\n.audit-process-checklist-num {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 1.75rem;\n  width: 1.75rem;\n  height: 1.75rem;\n  font-weight: 600;\n  font-size: 0.875rem;\n  color: var(--tblr-primary, #206bc4);\n  background: rgba(32, 107, 196, 0.1);\n  border: 1px solid var(--tblr-primary, #206bc4);\n  border-radius: 50%;\n}\n\n.audit-process-checklist-view-btn {\n  color: var(--tblr-primary, #206bc4);\n  background: rgba(32, 107, 196, 0.1);\n  border: 1px solid var(--tblr-primary, #206bc4);\n}\n\n.audit-process-checklist-view-btn:hover {\n  color: #fff;\n  background: var(--tblr-primary, #206bc4);\n}\n\n.audit-process-checklist-label {\n  flex: 1;\n  min-width: 80px;\n}\n\n.audit-process-checklist-options {\n  display: flex;\n  align-items: center;\n  gap: 1.25rem;\n}\n\n.audit-process-checklist-notes {\n  width: 100%;\n  flex-basis: 100%;\n  margin-left: 0;\n  padding-left: calc(1.5rem + 0.75rem);\n}\n\n.audit-process-checklist-notes .form-label {\n  margin-bottom: 0.35rem;\n}\n\n.audit-process-radio-ok,\n.audit-process-radio-revisi {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  cursor: pointer;\n  font-size: 0.9rem;\n  margin: 0;\n  padding: 0.4rem 0.75rem;\n  border-radius: 6px;\n  border: 1px solid var(--tblr-border-color, #e6e7e9);\n  background: transparent;\n  color: var(--tblr-secondary, #6c757d);\n  transition: background 0.15s ease, border-color 0.15s ease, color 0.15s ease;\n}\n\n.audit-process-radio-ok input,\n.audit-process-radio-revisi input {\n  width: 1.1rem;\n  height: 1.1rem;\n  accent-color: #0d9488;\n}\n\n.audit-process-radio-ok.is-selected {\n  background: rgba(25, 135, 84, 0.12);\n  border-color: #198754;\n  color: #198754;\n}\n\n.audit-process-radio-ok input {\n  accent-color: #198754;\n}\n\n.audit-process-radio-revisi.is-selected {\n  background: rgba(220, 53, 69, 0.12);\n  border-color: #dc3545;\n  color: #dc3545;\n}\n\n.audit-process-radio-revisi input {\n  accent-color: #dc3545;\n}\n\n.audit-process-notes {\n  resize: vertical;\n  min-height: 80px;\n  border-radius: 6px;\n}\n\n.audit-process-btn-revision {\n  border-color: #dc3545;\n  color: #dc3545;\n  border-radius: 6px;\n}\n\n.audit-process-btn-revision:hover {\n  background: rgba(220, 53, 69, 0.1);\n  border-color: #dc3545;\n  color: #dc3545;\n}\n\n.audit-process-btn-continue {\n  border-radius: 6px;\n}\n\n/* Badges (if not in theme) */\n.bg-success-lt {\n  background: rgba(25, 135, 84, 0.15);\n}\n\n.text-success {\n  color: #198754 !important;\n}\n\n.bg-warning-lt {\n  background: rgba(255, 193, 7, 0.2);\n}\n\n.text-warning {\n  color: #b8860b !important;\n}\n\n/* Project History timeline */\n.audit-process-timeline {\n  position: relative;\n  padding-left: 1.5rem;\n}\n\n.audit-process-timeline-item {\n  position: relative;\n  padding-bottom: 1.25rem;\n}\n\n.audit-process-timeline-item:last-child {\n  padding-bottom: 0;\n}\n\n.audit-process-timeline-marker {\n  position: absolute;\n  left: -1.5rem;\n  top: 0.4rem;\n  width: 10px;\n  height: 10px;\n  border-radius: 50%;\n  background: #0d9488;\n  border: 2px solid #fff;\n  box-shadow: 0 0 0 1px #0d9488;\n}\n\n.audit-process-timeline-item::before {\n  content: '';\n  position: absolute;\n  left: -1.125rem;\n  top: 1.25rem;\n  bottom: -0.5rem;\n  width: 2px;\n  background: rgba(13, 148, 136, 0.35);\n}\n\n.audit-process-timeline-item:last-child::before {\n  display: none;\n}\n\n.audit-process-timeline-content strong {\n  display: block;\n  margin-bottom: 0.15rem;\n}\n\n.audit-process-timeline-content p {\n  font-size: 0.875rem;\n}\n\n/* Confirmation modal – icon on top, no title bar */\n.audit-process-confirm-modal-content .modal-header {\n  justify-content: flex-end;\n}\n\n.audit-process-confirm-icon {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 3.25rem;\n  height: 3.25rem;\n  border-radius: 50%;\n  margin-bottom: 1rem;\n}\n\n.audit-process-confirm-icon-danger {\n  background: #dc3545;\n  color: #fff;\n  box-shadow: 0 0 0 4px rgba(220, 53, 69, 0.25);\n}\n\n.audit-process-confirm-icon-warning {\n  background: #ffc107;\n  color: #fff;\n  box-shadow: 0 0 0 4px rgba(255, 193, 7, 0.35);\n}\n\n.audit-process-confirm-icon-success {\n  background: #22c55e;\n  color: #fff;\n  box-shadow: 0 0 0 4px rgba(34, 197, 94, 0.25);\n}\n\n.audit-process-confirm-title {\n  font-weight: 600;\n  color: var(--tblr-body-color, #1e293b);\n  font-size: 1.1rem;\n}\n\n.audit-process-confirm-body {\n  font-size: 0.9375rem;\n  line-height: 1.5;\n}\n\n/* Scheduling */\n.audit-process-scheduling-subtabs {\n  display: flex;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.audit-process-scheduling-wizard {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  gap: 0.5rem;\n  padding: 0.65rem;\n  border: 1px solid #dce8e8;\n  border-radius: 0.75rem;\n  background: linear-gradient(135deg, #f7fbfb, #eef7f6);\n}\n\n.audit-process-scheduling-wizard-step {\n  min-height: 3.25rem;\n  display: flex;\n  align-items: center;\n  gap: 0.55rem;\n  padding: 0.6rem 0.7rem;\n  border: 1px solid transparent;\n  border-radius: 0.6rem;\n  background: transparent;\n  color: #5f7075;\n  font-size: 0.77rem;\n  font-weight: 600;\n  text-align: left;\n  transition: border-color 160ms ease, background-color 160ms ease, color 160ms ease;\n}\n\n.audit-process-scheduling-wizard-step:hover,\n.audit-process-scheduling-wizard-step:focus-visible {\n  border-color: #83c9c5;\n  outline: none;\n}\n\n.audit-process-scheduling-wizard-step.active {\n  border-color: #2ca8a1;\n  background: #fff;\n  color: #146d69;\n  box-shadow: 0 5px 14px rgba(30, 115, 111, 0.1);\n}\n\n.audit-process-scheduling-wizard-step.completed {\n  color: #27843f;\n}\n\n.audit-process-scheduling-wizard-index {\n  width: 1.65rem;\n  height: 1.65rem;\n  flex: 0 0 1.65rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background: #dbe7e7;\n  font-size: 0.72rem;\n}\n\n.audit-process-scheduling-wizard-step.active .audit-process-scheduling-wizard-index {\n  background: #1f8e88;\n  color: #fff;\n}\n\n.audit-process-scheduling-wizard-step.completed .audit-process-scheduling-wizard-index {\n  background: #dff4e3;\n  color: #27843f;\n}\n\n.audit-process-scheduling-status {\n  display: inline-flex;\n  align-items: center;\n  border-radius: 999px;\n  padding: 0.35rem 0.7rem;\n  background: #edf1f2;\n  color: #59686d;\n  font-size: 0.75rem;\n  font-weight: 700;\n}\n\n.audit-process-scheduling-status-confirmed { background: #dcf5e3; color: #25783b; }\n.audit-process-scheduling-status-in-progress { background: #fff1cf; color: #99670d; }\n\n.audit-process-scheduling-assignee {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  border-radius: 999px;\n  padding: 0.35rem 0.7rem;\n  background: #e6f0fd;\n  color: #1f5eab;\n  font-size: 0.75rem;\n  font-weight: 700;\n}\n\n.audit-process-scheduling-assignee strong {\n  font-weight: 700;\n}\n\n.audit-process-review-grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 0.75rem;\n}\n\n.audit-process-review-metric {\n  min-height: 8rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  padding: 1rem;\n  border: 1px solid #dce8e8;\n  border-top: 3px solid #2ca8a1;\n  border-radius: 0.65rem;\n  background: #fff;\n}\n\n.audit-process-review-metric span { color: #708086; font-size: 0.72rem; text-transform: uppercase; letter-spacing: 0.04em; }\n.audit-process-review-metric strong { color: #173f42; font-size: 1.55rem; }\n.audit-process-review-metric small { color: #657579; line-height: 1.35; }\n\n.audit-process-wizard-actions {\n  display: flex;\n  justify-content: space-between;\n  padding-top: 1rem;\n  border-top: 1px solid #e3ebec;\n}\n\n.audit-process-wizard-saved-flash {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.3rem;\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: #15803d;\n}\n\n@media (max-width: 991.98px) {\n  .audit-process-scheduling-wizard { grid-template-columns: 1fr; }\n  .audit-process-scheduling-wizard-step { min-height: 2.75rem; }\n  .audit-process-review-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }\n}\n\n@media (max-width: 575.98px) {\n  .audit-process-review-grid { grid-template-columns: 1fr; }\n}\n\n.audit-process-scheduling-toolbar {\n  border: 1px solid #dbe3ec;\n  border-radius: 10px;\n  padding: 0.8rem;\n  background: #f8fafc;\n}\n\n.audit-process-scheduling-lock {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n  padding: 0.875rem 1rem;\n  color: #6b4b0f;\n  background: linear-gradient(135deg, #fff9e8 0%, #fff4cf 100%);\n  border: 1px solid #e9c96c;\n  border-left: 4px solid #c28a18;\n  border-radius: 0.65rem;\n}\n\n.audit-process-scheduling-lock__icon {\n  display: inline-grid;\n  place-items: center;\n  flex: 0 0 2rem;\n  width: 2rem;\n  height: 2rem;\n  color: #8d650e;\n  background: rgba(255, 255, 255, 0.75);\n  border-radius: 50%;\n}\n\n.audit-process-scheduling-lock p {\n  margin-top: 0.15rem;\n  color: #7b5b1d;\n  font-size: 0.82rem;\n  line-height: 1.45;\n}\n\n.audit-process-scheduling-subtab {\n  border: 1px solid #d1d5db;\n  background: #ffffff;\n  color: #374151;\n  border-radius: 8px;\n  padding: 0.45rem 0.8rem;\n  font-weight: 600;\n  font-size: 0.9rem;\n}\n\n.audit-process-scheduling-subtab.active {\n  border-color: #0d9488;\n  color: #0f766e;\n  background: #ecfeff;\n}\n\n.audit-process-scheduling-card {\n  border: 1px solid #dbe3ec;\n  border-radius: 10px;\n  overflow: hidden;\n  background: #ffffff;\n}\n\n.audit-process-scheduling-card-date-picker {\n  overflow: visible;\n  position: relative;\n}\n\n.audit-process-scheduling-card-header {\n  padding: 0.75rem 1rem;\n  background: #f8fafc;\n  border-bottom: 1px solid #e5e7eb;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.audit-process-scheduling-card-header h5 {\n  font-size: 1rem;\n  font-weight: 700;\n  color: #334155;\n}\n\n.audit-process-scheduling-card-body {\n  padding: 1rem;\n}\n\n.audit-process-add-auditor-bottom {\n  position: sticky;\n  bottom: 0;\n  z-index: 3;\n  display: flex;\n  gap: 0.5rem;\n  justify-content: flex-end;\n  margin-top: 0.75rem;\n  padding: 0.65rem 0;\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, #ffffff 38%);\n}\n\n.audit-process-save-warning-label {\n  margin-right: auto;\n  display: inline-flex;\n  align-items: center;\n  padding: 0.42rem 0.7rem;\n  border-radius: 8px;\n  border: 1px solid #f59e0b;\n  background: #fffbeb;\n  color: #b45309;\n  font-size: 0.82rem;\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.audit-process-scheduling-action-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.35rem;\n  min-height: 2.5rem;\n  border-radius: 10px;\n  font-weight: 700;\n  letter-spacing: 0.01em;\n  padding: 0.48rem 1rem;\n  transition-property: color, background-color, background-image, border-color, box-shadow;\n  transition-duration: 0.16s;\n  transition-timing-function: ease;\n}\n\n.audit-process-scheduling-action-btn-primary {\n  color: #ffffff;\n  border: 1px solid #0f766e;\n  background: linear-gradient(135deg, #14b8a6 0%, #0d9488 100%);\n  box-shadow: 0 4px 12px rgba(13, 148, 136, 0.22);\n}\n\n.audit-process-scheduling-action-btn-primary:hover:not(:disabled) {\n  color: #ffffff;\n  border-color: #0f766e;\n  background: linear-gradient(135deg, #0d9488 0%, #0f766e 100%);\n  box-shadow: 0 6px 16px rgba(13, 148, 136, 0.28);\n  transform: translateY(-1px);\n}\n\n.audit-process-scheduling-action-btn-secondary {\n  color: #0f766e;\n  border: 1px solid #5eead4;\n  background: #f0fdfa;\n}\n\n.audit-process-scheduling-action-btn-secondary:hover:not(:disabled) {\n  color: #0f766e;\n  border-color: #2dd4bf;\n  background: #ccfbf1;\n  transform: translateY(-1px);\n}\n\n.audit-process-scheduling-action-btn:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n  transform: none;\n}\n\n.audit-process-mandays-total-label {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.22rem 0.6rem;\n  border-radius: 999px;\n  background: #e6fffb;\n  border: 1px solid #99f6e4;\n  color: #0f766e;\n  font-size: 0.78rem;\n  font-weight: 700;\n  line-height: 1.2;\n}\n\n.audit-process-site-chip-wrap {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.45rem;\n}\n\n.audit-process-site-chip {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.24rem 0.55rem;\n  border-radius: 999px;\n  border: 1px solid #bae6fd;\n  color: #0369a1;\n  background: #f0f9ff;\n  font-size: 0.8rem;\n  font-weight: 600;\n}\n\n.audit-process-site-options {\n  border: 1px solid #dbe3ec;\n  border-radius: 8px;\n  padding: 0.55rem;\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 0.45rem;\n}\n\n.audit-process-site-option {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n  font-size: 0.9rem;\n  color: #334155;\n}\n\n.audit-process-linked-auditors {\n  margin-top: 0.25rem;\n}\n\n.audit-process-linked-auditor-item-legacy {\n  padding: 0.6rem 0.75rem;\n  display: grid;\n  grid-template-columns: 1.2fr 0.8fr 0.8fr;\n  gap: 0.6rem;\n  border-bottom: 1px solid #e5e7eb;\n  font-size: 0.9rem;\n  color: #334155;\n}\n\n.audit-process-linked-auditor-item-legacy:last-child {\n  border-bottom: none;\n}\n\n.audit-process-accommodation-box {\n  border: 1px solid #dbe3ec;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.audit-process-accommodation-box-header {\n  background: #f8fafc;\n  border-bottom: 1px solid #e5e7eb;\n  padding: 0.6rem 0.85rem;\n  font-weight: 700;\n  font-size: 0.9rem;\n  color: #334155;\n}\n\n.audit-process-accommodation-box-body {\n  padding: 0.85rem;\n}\n\n.audit-process-uploaded-list {\n  border: 1px solid #dbe3ec;\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.audit-process-uploaded-item {\n  padding: 0.5rem 0.7rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 1px solid #e5e7eb;\n}\n\n.audit-process-uploaded-item:last-child {\n  border-bottom: none;\n}\n\n.audit-process-accommodation-schedule-select {\n  border-color: #99f6e4;\n  background: #f8fffe;\n}\n\n.audit-process-accommodation-schedule-select:focus {\n  border-color: #14b8a6;\n  box-shadow: 0 0 0 3px rgba(20, 184, 166, 0.16);\n}\n\n.audit-process-accommodation-schedule-preview {\n  display: flex;\n  flex-direction: column;\n  gap: 0.6rem;\n}\n\n.audit-process-accommodation-schedule-head {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.audit-process-accommodation-schedule-meta {\n  display: flex;\n  gap: 0.4rem;\n  flex-wrap: wrap;\n}\n\n.audit-process-accommodation-date-actions {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.audit-process-accommodation-date-grid {\n  gap: 0.45rem;\n}\n\n.audit-process-accommodation-date-pill {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.3rem 0.7rem;\n  border-radius: 999px;\n  border: 1px solid #99f6e4;\n  background: #ecfeff;\n  color: #0f766e;\n  font-size: 0.78rem;\n  font-weight: 700;\n  letter-spacing: 0.01em;\n  transition-property: color, background-color, background-image, border-color, box-shadow;\n  transition-duration: 0.16s;\n  transition-timing-function: ease;\n}\n\n.audit-process-accommodation-date-pill:hover {\n  border-color: #14b8a6;\n  background: #d9fffb;\n}\n\n.audit-process-accommodation-date-pill.active {\n  border-color: #0d9488;\n  background: linear-gradient(135deg, #14b8a6 0%, #0d9488 100%);\n  color: #ffffff;\n  box-shadow: 0 3px 8px rgba(13, 148, 136, 0.26);\n}\n\n@keyframes audit-process-shimmer {\n  0%,\n  100% {\n    transform: translateX(-130%) rotate(25deg);\n    opacity: 0;\n  }\n  18% {\n    opacity: 0;\n  }\n  42% {\n    opacity: 0.95;\n  }\n  62% {\n    transform: translateX(280%) rotate(25deg);\n    opacity: 0;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .audit-process-stage-item.is-expanded::after,\n  .audit-process-inline-major-item.is-current::after {\n    animation: none;\n  }\n}\n\n@media (max-width: 768px) {\n  .audit-process-header-inner {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .audit-process-inline-stepper {\n    padding: 0.7rem;\n  }\n\n  .audit-process-inline-major-item {\n    min-width: 150px;\n  }\n\n  .audit-process-contact-grid {\n    grid-template-columns: 1fr;\n    row-gap: 0.35rem;\n  }\n\n  .audit-process-contact-colon {\n    display: none;\n  }\n\n  .audit-process-contact-label {\n    margin-top: 0.2rem;\n  }\n\n  .audit-process-linked-auditor-item {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .audit-process-calendar-picker {\n    width: 94vw;\n    min-width: 0;\n    max-width: 94vw;\n    max-height: 85vh;\n    padding: 0.85rem;\n  }\n\n  .audit-process-calendar-picker .calendar-month-header h6 {\n    min-width: 120px;\n  }\n\n  .audit-process-calendar-picker .calendar-grid {\n    gap: 0.2rem;\n  }\n\n  .calendar-day {\n    font-size: 0.75rem;\n    min-height: 38px;\n  }\n\n  .audit-process-selected-dates {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .audit-process-date-badge {\n    width: 100%;\n    justify-content: center;\n  }\n\n  .audit-process-date-selection-panel {\n    grid-template-columns: 1fr;\n    padding: 0.7rem;\n  }\n\n  .audit-process-date-picker-trigger {\n    min-height: 2.75rem;\n    font-size: 0.92rem;\n    border-radius: 9px;\n  }\n\n  .audit-process-date-picker-count {\n    margin-top: 0.35rem;\n    font-size: 0.84rem;\n  }\n\n  .audit-process-date-selection-preview .audit-process-selected-dates {\n    max-height: none;\n    overflow: visible;\n    padding-right: 0;\n  }\n\n  .audit-process-add-auditor-bottom {\n    flex-direction: column;\n    justify-content: stretch;\n  }\n\n  .audit-process-add-auditor-bottom .btn {\n    width: 100%;\n  }\n\n  .audit-process-save-warning-label {\n    width: 100%;\n    margin-right: 0;\n    justify-content: center;\n    text-align: center;\n  }\n\n  .audit-process-scheduling-action-btn {\n    width: 100%;\n  }\n\n  .audit-process-accommodation-schedule-head {\n    align-items: flex-start;\n  }\n\n  .audit-process-accommodation-date-actions {\n    justify-content: flex-start;\n  }\n}\n\n/* ── Manday + Site combined row ───────────────────────────────── */\n.audit-process-manday-site-row {\n  background: linear-gradient(135deg, #f8fafc 0%, #f0fdfa 100%);\n  border: 1px solid #d1fae5 !important;\n  border-left: 3px solid #14b8a6 !important;\n  border-radius: 10px;\n  padding: 0.85rem 1rem;\n  transition: box-shadow 0.18s ease, border-color 0.18s ease;\n}\n\n.audit-process-manday-site-row:hover {\n  box-shadow: 0 2px 10px rgba(20, 184, 166, 0.1);\n  border-color: #a7f3d0 !important;\n  border-left-color: #0d9488 !important;\n}\n\n.audit-process-manday-site-row .form-control-sm {\n  background: #ffffff;\n  border-color: #d1d5db;\n}\n\n/* ── Site selection pill toggle buttons ───────────────────────── */\n.audit-process-site-pills-wrap {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n  align-items: center;\n}\n\n.audit-process-site-pill {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.3rem 0.75rem;\n  border-radius: 999px;\n  border: 1.5px solid #cbd5e1;\n  background: #ffffff;\n  color: #475569;\n  font-size: 0.8rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition-property: color, background-color, background-image, border-color, box-shadow;\n  transition-duration: 0.15s;\n  transition-timing-function: ease;\n  white-space: nowrap;\n  user-select: none;\n  line-height: 1.4;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n}\n\n.audit-process-site-pill:hover:not(:disabled) {\n  border-color: #14b8a6;\n  color: #0f766e;\n  background: #f0fdfa;\n  box-shadow: 0 1px 5px rgba(20, 184, 166, 0.18);\n}\n\n.audit-process-site-pill.active {\n  background: linear-gradient(135deg, #14b8a6 0%, #0d9488 100%);\n  border-color: #0d9488;\n  color: #ffffff;\n  box-shadow: 0 2px 6px rgba(13, 148, 136, 0.35);\n}\n\n.audit-process-site-pill.active:hover:not(:disabled) {\n  background: linear-gradient(135deg, #0d9488 0%, #0f766e 100%);\n  border-color: #0f766e;\n}\n\n.audit-process-site-pill:disabled {\n  opacity: 0.4;\n  cursor: not-allowed;\n}\n\n/* ── Site Location tab: auditor + date display ────────────────── */\n.audit-process-linked-auditors {\n  border: 1px solid #e2e8f0;\n  border-radius: 8px;\n  overflow: hidden;\n  background: #ffffff;\n}\n\n.audit-process-linked-auditor-item {\n  padding: 0.65rem 0.85rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.35rem;\n  border-bottom: 1px solid #f1f5f9;\n  font-size: 0.9rem;\n}\n\n.audit-process-linked-auditor-item:last-child {\n  border-bottom: none;\n}\n\n.audit-process-linked-auditor-name {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.audit-process-linked-auditor-type {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.15rem 0.5rem;\n  border-radius: 6px;\n  background: #f1f5f9;\n  color: #64748b;\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n\n.audit-process-auditor-dates {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.35rem;\n}\n\n.audit-process-auditor-date-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.18rem 0.55rem;\n  border-radius: 6px;\n  background: #eff6ff;\n  border: 1px solid #bfdbfe;\n  color: #1d4ed8;\n  font-size: 0.73rem;\n  font-weight: 500;\n  font-variant-numeric: tabular-nums;\n  letter-spacing: 0.01em;\n}\n\n/* ── Date Range Picker ───────────────────────────────────────── */\n.audit-process-date-range-picker-wrapper {\n  position: relative;\n  z-index: 5;\n}\n\n.audit-process-date-selection-panel {\n  display: grid;\n  grid-template-columns: minmax(280px, 1fr) minmax(260px, 1fr);\n  gap: 0.8rem;\n  align-items: start;\n  padding: 0.85rem;\n  border: 1px solid #d1fae5;\n  border-radius: 12px;\n  background: linear-gradient(145deg, #f8fafc 0%, #f0fdfa 100%);\n}\n\n.audit-process-date-picker-trigger {\n  width: 100%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 3rem;\n  padding: 0.5rem 0.85rem;\n  border: 1px solid #99f6e4;\n  border-radius: 10px;\n  background: #ffffff;\n  color: #0f766e;\n  font-size: 1rem;\n  font-weight: 700;\n  line-height: 1.2;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n  transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;\n}\n\n.audit-process-date-picker-count {\n  margin-top: 0.45rem;\n  font-size: 0.9rem;\n  font-weight: 600;\n  color: #475569;\n}\n\n.audit-process-date-picker-trigger:hover {\n  border-color: #14b8a6;\n  background: #f0fdfa;\n}\n\n.audit-process-date-picker-trigger:focus-visible {\n  outline: none;\n  border-color: #0d9488;\n  box-shadow: 0 0 0 3px rgba(13, 148, 136, 0.2);\n}\n\n.audit-process-date-selection-preview {\n  display: flex;\n  flex-direction: column;\n  gap: 0.45rem;\n  min-width: 0;\n}\n\n.audit-process-selected-dates-title {\n  font-size: 0.78rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: #0f766e;\n}\n\n.audit-process-calendar-picker {\n  position: fixed;\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  background: #ffffff;\n  border: 1px solid #e5e7eb;\n  border-radius: 10px;\n  padding: 1rem;\n  margin-top: 0;\n  box-shadow: 0 20px 48px rgba(15, 23, 42, 0.2);\n  z-index: 1060;\n  width: min(92vw, 440px);\n  min-width: 320px;\n  max-width: 92vw;\n  display: flex;\n  flex-direction: column;\n  max-height: 82vh;\n  overflow-y: auto;\n}\n\n.audit-process-calendar-picker .calendar-month-header {\n  text-align: center;\n  margin-bottom: 0.75rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid #f1f5f9;\n  font-weight: 600;\n  color: #1f2937;\n  font-size: 0.95rem;\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n}\n\n.audit-process-calendar-picker .calendar-month-header .btn-link {\n  color: #64748b;\n  text-decoration: none;\n  font-size: 1.2rem;\n  line-height: 1;\n}\n\n.audit-process-calendar-picker .calendar-month-header .btn-link:hover {\n  color: #14b8a6;\n}\n\n.audit-process-calendar-picker .calendar-weekdays {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 0.2rem;\n  margin-bottom: 0.5rem;\n  text-align: center;\n  flex-shrink: 0;\n}\n\n.audit-process-calendar-picker .calendar-weekdays div {\n  font-size: 0.7rem;\n  font-weight: 600;\n  color: #6b7280;\n  padding: 0.35rem 0;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.audit-process-calendar-picker .calendar-grid {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 0.25rem;\n  margin-bottom: 0.75rem;\n  flex-grow: 1;\n}\n\n.calendar-day {\n  aspect-ratio: 1;\n  padding: 0;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  background: #ffffff;\n  color: #1f2937;\n  font-size: 0.8rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition-property: color, background-color, border-color;\n  transition-duration: 0.15s;\n  transition-timing-function: ease;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 40px;\n}\n\n.calendar-day:hover:not(:disabled) {\n  border-color: #14b8a6;\n  background: #f0fdfa;\n  color: #0d9488;\n}\n\n.calendar-day.other-month {\n  color: #d1d5db;\n  background: #f9fafb;\n  cursor: not-allowed;\n}\n\n.calendar-day.availability-half {\n  background: #fff7ed;\n  border-color: #fb923c;\n  color: #9a3412;\n}\n\n.calendar-day.availability-full {\n  background: #fef2f2;\n  border-color: #ef4444;\n  color: #b91c1c;\n  font-weight: 700;\n}\n\n.calendar-day.availability-half:hover:not(:disabled),\n.calendar-day.availability-full:hover:not(:disabled) {\n  filter: brightness(0.97);\n}\n\n.calendar-day.selected {\n  background: linear-gradient(135deg, #14b8a6 0%, #0d9488 100%);\n  border-color: #0d9488;\n  color: #ffffff;\n  font-weight: 600;\n  box-shadow: 0 2px 6px rgba(13, 148, 136, 0.35);\n}\n\n.calendar-day.selected:hover {\n  box-shadow: 0 4px 10px rgba(13, 148, 136, 0.45);\n}\n\n.calendar-availability-legend {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.65rem;\n  margin: 0 0 0.65rem;\n  font-size: 0.72rem;\n}\n\n.calendar-availability-legend span {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.25rem;\n}\n\n.calendar-availability-swatch {\n  width: 0.7rem;\n  height: 0.7rem;\n  border-radius: 3px;\n  border: 1px solid transparent;\n}\n\n.calendar-availability-swatch.half {\n  background: #fff7ed;\n  border-color: #fb923c;\n}\n\n.calendar-availability-swatch.full {\n  background: #fef2f2;\n  border-color: #ef4444;\n}\n\n.calendar-day:disabled {\n  cursor: not-allowed;\n}\n\n.audit-process-calendar-picker .calendar-actions {\n  display: flex;\n  gap: 0.5rem;\n  justify-content: flex-end;\n  padding-top: 0.75rem;\n  border-top: 1px solid #f1f5f9;\n  flex-shrink: 0;\n}\n\n.audit-process-calendar-picker .calendar-actions button {\n  min-width: 80px;\n  font-weight: 500;\n}\n\n.audit-process-calendar-picker .calendar-actions .badge {\n  font-weight: 600;\n  font-size: 0.7rem;\n  padding: 0.25rem 0.45rem;\n}\n\n/* ── Selected dates display ──────────────────────────────────── */\n.audit-process-selected-dates {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n  align-items: center;\n}\n\n.audit-process-date-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: 0.35rem 0.8rem;\n  border-radius: 20px;\n  background: linear-gradient(135deg, #14b8a6 0%, #0d9488 100%);\n  color: #ffffff;\n  font-size: 0.8rem;\n  font-weight: 600;\n  letter-spacing: 0.02em;\n  box-shadow: 0 2px 8px rgba(13, 148, 136, 0.28);\n  white-space: nowrap;\n}\n\n.audit-process-date-badge:hover {\n  box-shadow: 0 4px 12px rgba(13, 148, 136, 0.38);\n}\n\n.audit-process-date-selection-preview .audit-process-selected-dates {\n  max-height: 8.5rem;\n  overflow-y: auto;\n  padding-right: 0.2rem;\n}\n\n/* Shared Audit Scope selector. This wrapper is deliberately local to the\n   Audit Process page: proposal scope may populate information fields, while\n   this explicit selector remains the source of the active workflow context. */\n.audit-process-scope-selector {\n  position: relative;\n  padding: 0.9rem 1rem 1rem;\n  border: 1px solid #b9dcd9;\n  border-radius: 12px;\n  background: linear-gradient(135deg, #f8fffe 0%, #f2fbfa 100%);\n  box-shadow: 0 7px 20px rgba(15, 118, 110, 0.07);\n  transition: border-color 160ms ease, box-shadow 160ms ease, background 160ms ease;\n}\n\n.audit-process-scope-selector.is-pending {\n  border-color: #f59e0b;\n  background: linear-gradient(135deg, #fffdf5 0%, #fff8e8 100%);\n  box-shadow: 0 0 0 3px rgba(245, 158, 11, 0.1), 0 8px 22px rgba(146, 93, 8, 0.08);\n}\n\n.audit-process-scope-selector.is-selected:focus-within {\n  border-color: #0f8f83;\n  box-shadow: 0 0 0 3px rgba(15, 143, 131, 0.13), 0 8px 24px rgba(15, 118, 110, 0.1);\n}\n\n.audit-process-scope-selector__prompt {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.45rem;\n  margin-bottom: 0.65rem;\n  color: #315e61;\n  font-size: 0.75rem;\n  line-height: 1.4;\n}\n\n.audit-process-scope-selector.is-pending .audit-process-scope-selector__prompt {\n  color: #995d08;\n}\n\n.audit-process-scope-selector__prompt svg {\n  flex: 0 0 auto;\n  margin-top: 0.05rem;\n}\n\n.audit-process-scope-selector .form-label {\n  margin-bottom: 0.4rem;\n  color: #173f43;\n  font-weight: 700;\n}\n\n.audit-process-scope-select {\n  min-height: 44px;\n  border: 1px solid #87c8c2;\n  border-radius: 9px;\n  color: #193b40;\n  background-color: #fff;\n  font-weight: 600;\n  box-shadow: inset 0 1px 2px rgba(15, 23, 42, 0.03);\n}\n\n.audit-process-scope-select:hover,\n.audit-process-scope-select:focus {\n  border-color: #0f8f83;\n  box-shadow: 0 0 0 0.2rem rgba(15, 143, 131, 0.12);\n}\n\n.audit-process-scope-selector__hint {\n  display: block;\n  margin-top: 0.45rem;\n  color: #687d80;\n  font-size: 0.7rem;\n}\n\n@media (max-width: 575.98px) {\n  .audit-process-scope-selector { padding: 0.8rem; }\n  .audit-process-scope-selector__prompt { font-size: 0.72rem; }\n}\n\n/* AP-012: ensure a clear dropdown caret on select fields inside the audit\n   document form (Scheduling Scope, service item, etc.) so users can tell\n   the field is a selectable dropdown. Scoped to the modal — no global impact. */\n.audit-doc-form-modal .form-select {\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='%230f766e' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/%3e%3c/svg%3e\");\n  background-repeat: no-repeat;\n  background-position: right 0.55rem center;\n  background-size: 14px 11px;\n  padding-right: 2rem;\n}\n\n/* Integrated / Combined methodology group banner (#17) */\n.audit-process-methodology-group {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.4rem;\n  padding: 0.5rem 0.75rem;\n  border: 1px dashed #99e0da;\n  border-radius: 8px;\n  background: #f3fbfa;\n}\n\n/* Point-4 auto-focus: scrollIntoView({block:'start'}) aligns this section's\n   top edge with the viewport top. On mobile that lands directly behind the\n   fixed .mobile-navbar (64px tall, position:fixed) -- the section's own\n   heading would render hidden under it. scroll-margin-top reserves that\n   space so the browser's native scroll-into-view (used by our own\n   scrollIntoView call and by anchor/keyboard navigation alike) stops below\n   the navbar instead of under it. */\n@media (max-width: 991.98px) {\n  .audit-process-primary-doc-section {\n    scroll-margin-top: 76px;\n  }\n}\n\n/* Point-4 (sticky mini-stepper): keeps Stage 1/2 + Review->Audit->TR->Certificate\n   progress visible while the user scrolls past the full stepper card. Pure CSS\n   `position: sticky` (same idiom as Analysis's `.analysis-sticky-stack`) -- no\n   scroll-listener JS needed. Sits below the fixed .mobile-navbar (z-index 1030). */\n.audit-process-sticky-stepper {\n  position: sticky;\n  top: 0;\n  z-index: 900;\n  margin: 0 0 1rem;\n  padding: 0.5rem 0;\n  background: linear-gradient(180deg, rgba(255, 255, 255, 0.98) 0%, rgba(255, 255, 255, 0.94) 82%, rgba(255, 255, 255, 0) 100%);\n  backdrop-filter: blur(8px);\n}\n\n.audit-process-sticky-stepper-inner {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  padding: 0.55rem 0.9rem;\n  border-radius: 12px;\n  border: 1px solid #99e0da;\n  background: linear-gradient(135deg, #0d3d42 0%, #1f656c 55%, #2a8a93 100%);\n  box-shadow: 0 8px 20px rgba(15, 23, 42, 0.14);\n  overflow-x: auto;\n  scrollbar-width: none;\n}\n\n.audit-process-sticky-stepper-inner::-webkit-scrollbar {\n  display: none;\n}\n\n.audit-process-sticky-stepper-cycle {\n  flex-shrink: 0;\n  font-size: 0.78rem;\n  font-weight: 700;\n  color: #ecfeff;\n  padding-right: 0.75rem;\n  border-right: 1px solid rgba(255, 255, 255, 0.25);\n  white-space: nowrap;\n  max-width: 160px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.audit-process-sticky-stepper-cycle-badge {\n  flex-shrink: 0;\n  display: inline-flex;\n  align-items: center;\n  padding: 0.2rem 0.55rem;\n  margin-right: 0.75rem;\n  border-radius: 9999px;\n  font-size: 0.72rem;\n  font-weight: 700;\n  color: #1d4ed8;\n  background: #eff6ff;\n  border: 1px solid #bfdbfe;\n  white-space: nowrap;\n}\n\n.audit-process-sticky-stepper-steps {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  flex: 1;\n  min-width: 0;\n}\n\n.audit-process-sticky-step {\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  flex-shrink: 0;\n  opacity: 0.55;\n}\n\n.audit-process-sticky-step.is-completed {\n  opacity: 0.85;\n}\n\n.audit-process-sticky-step.is-current {\n  opacity: 1;\n}\n\n.audit-process-sticky-step-dot {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 18px;\n  height: 18px;\n  border-radius: 50%;\n  font-size: 0.68rem;\n  font-weight: 700;\n  color: #ffffff;\n  background: rgba(255, 255, 255, 0.18);\n  border: 1px solid rgba(255, 255, 255, 0.35);\n  flex-shrink: 0;\n}\n\n.audit-process-sticky-step.is-completed .audit-process-sticky-step-dot {\n  background: #2dd4bf;\n  border-color: #2dd4bf;\n  color: #0d3d42;\n}\n\n.audit-process-sticky-step.is-current .audit-process-sticky-step-dot {\n  background: #ffffff;\n  border-color: #ffffff;\n  color: #0d3d42;\n}\n\n.audit-process-sticky-step-label {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #ecfeff;\n  white-space: nowrap;\n}\n\n.audit-process-sticky-step-divider {\n  width: 14px;\n  height: 1px;\n  background: rgba(255, 255, 255, 0.3);\n  flex-shrink: 0;\n}\n\n.audit-process-sticky-stepper-cert-btn {\n  flex-shrink: 0;\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: #ffffff;\n  background: #0d9488;\n  border: none;\n  padding: 0.35rem 0.85rem;\n  border-radius: 999px;\n  white-space: nowrap;\n  text-decoration: none;\n  cursor: pointer;\n  transition: background-color 150ms ease;\n}\n\n.audit-process-sticky-stepper-cert-btn:hover {\n  background: #0f766e;\n  color: #ffffff;\n}\n\n.audit-process-sticky-stepper-cert-btn:focus-visible {\n  outline: 2px solid #0d3d42;\n  outline-offset: 2px;\n}\n\n.audit-process-sticky-stepper-cert-btn.is-disabled {\n  background: #e2e8f0;\n  color: #94a3b8;\n  cursor: not-allowed;\n}\n\n@media (max-width: 991.98px) {\n  .audit-process-sticky-stepper {\n    top: 64px;\n  }\n\n  .audit-process-sticky-stepper-cycle {\n    max-width: 110px;\n  }\n\n  .audit-process-sticky-step-label {\n    display: none;\n  }\n\n  .audit-process-sticky-stepper-cert-btn {\n    font-size: 0.68rem;\n    padding: 0.3rem 0.6rem;\n  }\n}\n\n.audit-process-pagination-pill-bar {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n  color: #6c757d;\n  font-size: 0.8125rem;\n}\n\n.audit-process-pagination-pill {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  background: rgba(0, 0, 0, 0.03);\n  border-radius: 24px;\n  padding: 4px;\n}\n\n.audit-process-pagination-pill__btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 30px;\n  height: 30px;\n  border: none;\n  border-radius: 50%;\n  padding: 0;\n  background: transparent;\n  color: #1a767e;\n  box-shadow: none;\n  cursor: pointer;\n  transition: background 0.15s ease, box-shadow 0.15s ease;\n}\n\n.audit-process-pagination-pill__btn:not(:disabled):hover {\n  background: #fff;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);\n}\n\n.audit-process-pagination-pill__btn:disabled {\n  color: #c1c7d0;\n  cursor: default;\n}\n\n.audit-process-pagination-pill__label {\n  padding: 0 0.5rem;\n  font-size: 0.78rem;\n  font-weight: 600;\n  color: #1a767e;\n}\n\n/* \"N/A — single standard\" marker on checklist item #8 (Reduction of Type). Sits inside\n   .audit-process-checklist-label, which is a flex child that already wraps, so the badge\n   drops under the label text on narrow screens instead of squeezing the OK/Need Revision\n   controls off the row. */\n.audit-process-checklist-na-badge {\n  display: inline-block;\n  padding: 0.15rem 0.5rem;\n  border-radius: 999px;\n  font-size: 0.75rem;\n  font-weight: 600;\n  line-height: 1.4;\n  white-space: nowrap;\n  color: var(--tblr-secondary, #667382);\n  background: rgba(102, 115, 130, 0.12);\n  border: 1px solid rgba(102, 115, 130, 0.25);\n}\n\n.audit-process-multisite-coverage {\n  padding: 1rem 1.1rem;\n  border: 1px solid #dce4e8;\n  border-left: 3px solid #1a767e;\n  border-radius: 0.6rem;\n  background: #f8fafb;\n  color: #253746;\n}\n\n.audit-process-multisite-coverage__header {\n  display: flex;\n  align-items: center;\n  gap: 0.65rem;\n  padding-bottom: 0.75rem;\n  border-bottom: 1px solid #e4eaed;\n}\n\n.audit-process-multisite-coverage__header strong,\n.audit-process-multisite-coverage__header span {\n  display: block;\n}\n\n.audit-process-multisite-coverage__header strong {\n  font-size: 0.85rem;\n  line-height: 1.25;\n}\n\n.audit-process-multisite-coverage__header div > span {\n  margin-top: 0.15rem;\n  color: #71808c;\n  font-size: 0.72rem;\n}\n\n.audit-process-multisite-coverage__icon {\n  display: grid !important;\n  width: 2rem;\n  height: 2rem;\n  place-items: center;\n  flex: 0 0 2rem;\n  border-radius: 0.45rem;\n  color: #1a767e;\n  background: #e2f1f1;\n}\n\n.audit-process-multisite-coverage__list {\n  display: grid;\n  gap: 0.5rem;\n  margin: 0;\n  padding: 0.8rem 0 0;\n  list-style: none;\n}\n\n.audit-process-multisite-coverage__item {\n  display: flex;\n  align-items: flex-start;\n  gap: 0.65rem;\n  min-width: 0;\n  padding: 0.55rem 0.65rem;\n  border: 1px solid #e5ebee;\n  border-radius: 0.45rem;\n  background: #fff;\n}\n\n.audit-process-multisite-coverage__number {\n  display: grid;\n  width: 1.35rem;\n  height: 1.35rem;\n  place-items: center;\n  flex: 0 0 1.35rem;\n  border-radius: 50%;\n  color: #1a767e;\n  background: #e2f1f1;\n  font-size: 0.68rem;\n  font-weight: 700;\n}\n\n.audit-process-multisite-coverage__details {\n  display: grid;\n  gap: 0.15rem;\n  min-width: 0;\n  font-size: 0.78rem;\n}\n\n.audit-process-multisite-coverage__details span {\n  color: #71808c;\n  overflow-wrap: anywhere;\n  line-height: 1.35;\n}\n\n.audit-process-multisite-coverage__hint {\n  margin-top: 0.75rem;\n  color: #71808c;\n  font-size: 0.72rem;\n  line-height: 1.4;\n}\n\n.audit-process-multisite-coverage__empty {\n  display: block;\n  padding-top: 0.8rem;\n  color: #b54747;\n  font-size: 0.78rem;\n}\n\n/* Per-standard readiness dot on the grouped FTRD-02 certificate tabs. Colour is\n   paired with a title attribute and visually-hidden text, so readiness is never\n   communicated by hue alone. */\n.audit-process-certificate-standard-tabs .nav-tabs .nav-link {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.45rem;\n}\n\n.audit-process-certificate-tab-dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  flex-shrink: 0;\n}\n\n.audit-process-certificate-tab-dot--ready {\n  background: #1a767e;\n}\n\n.audit-process-certificate-tab-dot--incomplete {\n  background: #ffffff;\n  border: 2px solid #c0392b;\n}\n\n/* ── Inline document form: read-only context strip ──────────────────────────\n   Replaces the old col-lg-4 sidebar (Client Info / Audit Scope & Criteria /\n   Reference Documents). A minmax-floored grid, not a flex row of columns, per\n   this repo's tile-layout rule: a plain flex row has no width floor and will\n   letter-wrap \"EAC-33L - Technology and Infrastructure\" once the container gets\n   narrow. Here the fields wrap to fewer per row instead of ever shrinking. */\n.audit-process-form-context {\n  border: 1px solid #e6edf3;\n  border-radius: var(--audit-r-card);\n  background: linear-gradient(180deg, #fbfdfd 0%, #ffffff 100%);\n}\n\n.audit-process-form-context__grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(190px, 1fr));\n  gap: 16px 24px;\n}\n\n/* Scope is prose, not a short value -- it gets the full width of the strip. */\n.audit-process-form-context__wide {\n  grid-column: 1 / -1;\n}\n\n.audit-process-form-context__label {\n  margin-bottom: 3px;\n  color: #6c757d;\n  font-size: 0.65rem;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n.audit-process-form-context__docs {\n  margin-top: 16px;\n  padding-top: 14px;\n  border-top: 1px solid #eef2f5;\n}\n\n.audit-process-form-context__doc {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.4rem;\n  max-width: 320px;\n  padding: 0.3rem 0.6rem;\n  border: 1px solid #e3eaef;\n  border-radius: var(--audit-r-input);\n  background: #f8fafb;\n  font-size: 0.8rem;\n}\n\n@media (max-width: 575.98px) {\n  .audit-process-form-context__doc {\n    max-width: 100%;\n  }\n}\n\n/* ── Inline document form: back button + breadcrumb ─────────────────────────\n   Back is the primary way out and reads as a control; the breadcrumb beside it\n   is orientation. They share a row on desktop and stack on narrow screens so\n   Back never gets squeezed against a long crumb trail. */\n.audit-process-form-topbar {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 12px 16px;\n}\n\n.audit-process-form-back {\n  display: inline-flex;\n  align-items: center;\n  border-radius: var(--audit-r-button);\n  white-space: nowrap;\n}\n\n.audit-process-form-breadcrumb {\n  --bs-breadcrumb-divider: '›';\n  font-size: 0.8rem;\n  margin: 0;\n}\n\n.audit-process-form-breadcrumb .breadcrumb-item,\n.audit-process-form-breadcrumb .breadcrumb-item span {\n  color: #6c757d;\n}\n\n.audit-process-form-breadcrumb .btn-link {\n  color: #1a767e;\n  font-size: 0.8rem;\n  text-decoration: none;\n  border: 0;\n}\n\n.audit-process-form-breadcrumb .btn-link:hover,\n.audit-process-form-breadcrumb .btn-link:focus-visible {\n  color: #0d5962;\n  text-decoration: underline;\n}\n\n.audit-process-form-breadcrumb .breadcrumb-item.active {\n  color: #16323f;\n  font-weight: 600;\n}\n\n@media (max-width: 575.98px) {\n  .audit-process-form-topbar {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .audit-process-form-back {\n    width: 100%;\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
